<template>
	<div>
		<!-- 订单列表 -->
		<div class="sub" style="user-select: none;" v-loading="loading">
			<div class="list" style="width: 100%;">
				<div class="img-box-header" style="width: 100%;background-color: #fff;" :style="{
					height: (systemHeight * 0.08) + 'px',
				}">
					<div v-for="(item, index) in headTitle" :class="chooseHeaderIndex == index ? 'chooseHeader' : 'header'"
						@click="changeHeaderIndex(index)" :style="{
							fontSize: (systemWidth * 0.020) + 'px',
							marginLeft: (systemWidth * 0.02) + 'px',
							lineHeight: (systemHeight * 0.07) + 'px'
						}">{{ item }}
					</div>
				</div>
				<div class="findList" style="width: 100%;">
					<div></div>
					<div class="intKuang" style="float: right;">
						<keyboard-input field="obj.searchVal" :value="obj.searchVal" clearable @input="getOrderSearch()"
							placeholder="搜索票号/买家" @inputChange="formItemChange"></keyboard-input>
					</div>

				</div>

				<div class="orderList">
					<el-scrollbar ref="scrollbar" :style="{ height: (systemHeight * 0.8) + 'px' }" style="width: 100%;overflow: auto;">
						<van-pull-refresh style="width: 100%;height: auto;" success-text="刷新成功" v-model="loading"
							@refresh="onRefresh">
							<van-list v-model="loading2" :finished="finished" :immediate-check="false" finished-text="没有更多了"
								@load="onLoad">
								<div v-for="(item, index) in orderList" style="background-color: #ffffff;border-radius: 5px;"
									:style="{ marginTop: (systemHeight * 0.01) + 'px', height: (systemHeight * 0.11) + 'px', marginLeft: (systemWidth * 0.005) + 'px', marginRight: (systemWidth * 0.005) + 'px', fontSize: (systemWidth * 0.015) + 'px', }"
									@click="lookOrder(item)">
									<div style="float: left;width: 10%;"
										:style="{ fontSize: (systemWidth * 0.013) + 'px', marginLeft: (systemWidth * 0.01) + 'px', marginRight: (systemWidth * 0.005) + 'px', }">
										<div style="font-weight: bold;"
											:style="{ lineHeight: (systemHeight * 0.06) + 'px', fontSize: (systemWidth * 0.018) + 'px' }">
											{{ item.piao_num }}
										</div>
										<span v-if="item.status != 0"
											:style="{ paddingLeft: (systemWidth * 0.01) + 'px', paddingRight: (systemWidth * 0.01) + 'px', paddingTop: (systemHeight * 0.005) + 'px', paddingBottom: (systemHeight * 0.005) + 'px' }"
											style="color:#41a863; ;font-weight: bold;border-radius: 20px;background-color: #e2eee7;">
											结清
										</span>
										<span v-if="item.status == 0"
											:style="{ paddingLeft: (systemWidth * 0.01) + 'px', paddingRight: (systemWidth * 0.01) + 'px', paddingTop: (systemHeight * 0.005) + 'px', paddingBottom: (systemHeight * 0.005) + 'px' }"
											style="color: red;font-weight: bold;border-radius: 20px;background-color: #e2eee7;">
											赊欠
										</span>
									</div>
									<div style="float: left;width: 25%;"
										:style="{ fontSize: (systemWidth * 0.018) + 'px', marginLeft: (systemWidth * 0.01) + 'px', marginRight: (systemWidth * 0.005) + 'px', }">
										<div style="font-weight: bold;background-color: red;"
											:style="{ fontSize: (systemWidth * 0.018) + 'px', lineHeight: (systemHeight * 0.06) + 'px', marginLeft: (systemWidth * 0.01) + 'px', marginRight: (systemWidth * 0.005) + 'px', }">
											<span style="float: left;"> {{ item.maijia }}</span>
										</div>
										<div style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis; width: 100%;"
											:style="{ fontSize: (systemWidth * 0.013) + 'px', marginLeft: (systemWidth * 0.01) + 'px', marginRight: (systemWidth * 0.005) + 'px', }">
											<span v-for="(item_detail, index) in item.order_detail">
												<span>{{ item_detail.goods_name }} </span>
												<span v-if="item_detail.unit == '公斤' || item_detail.unit == '斤'">
													{{ item_detail.weight }}{{ item_detail.unit }}×{{ item_detail.price }}
												</span>
												<span v-else>
													{{ item_detail.num }}{{ item_detail.unit }}×{{ item_detail.price }}
												</span>
											</span>
										</div>
									</div>
									<div style="float: left;width: 10%;"
										:style="{ fontSize: (systemWidth * 0.013) + 'px', marginLeft: (systemWidth * 0.01) + 'px', marginRight: (systemWidth * 0.005) + 'px', }">
										<div v-if="item.status == 0" style="font-weight: bold;color: red;"
											:style="{ fontSize: (systemWidth * 0.013) + 'px', lineHeight: (systemHeight * 0.05) + 'px', marginLeft: (systemWidth * 0.01) + 'px', marginRight: (systemWidth * 0.005) + 'px', }">
											金额
										</div>
										<div v-if="item.status != 0" style="font-weight: bold;color: #64a563;"
											:style="{ fontSize: (systemWidth * 0.013) + 'px', lineHeight: (systemHeight * 0.05) + 'px', marginLeft: (systemWidth * 0.01) + 'px', marginRight: (systemWidth * 0.005) + 'px', }">
											实收
										</div>
										<div v-if="item.status == 0" style="font-weight: bold;color: #666666;"
											:style="{ fontSize: (systemWidth * 0.018) + 'px', marginLeft: (systemWidth * 0.01) + 'px', marginRight: (systemWidth * 0.005) + 'px', }">
											{{ item.yingshou }}
										</div>
										<div v-if="item.status != 0" style="font-weight: bold;color: #666666;"
											:style="{ fontSize: (systemWidth * 0.018) + 'px', marginLeft: (systemWidth * 0.01) + 'px', marginRight: (systemWidth * 0.005) + 'px', }">
											{{ item.shishou }}
										</div>
									</div>
									<div style="float: left;width: 10%;"
										:style="{ fontSize: (systemWidth * 0.013) + 'px', marginLeft: (systemWidth * 0.01) + 'px', marginRight: (systemWidth * 0.005) + 'px', }">
										<div v-if="item.huan" style="font-weight: bold;color: #9b9b9b;text-align: center;"
											:style="{ fontSize: (systemWidth * 0.013) + 'px', lineHeight: (systemHeight * 0.05) + 'px', marginLeft: (systemWidth * 0.01) + 'px', marginRight: (systemWidth * 0.005) + 'px', }">
											已还
										</div>

										<div v-if="item.huan" style="font-weight: bold;color: #666666;text-align: center;"
											:style="{ fontSize: (systemWidth * 0.018) + 'px', marginLeft: (systemWidth * 0.01) + 'px', marginRight: (systemWidth * 0.005) + 'px', }">
											{{ item.huan }}
										</div>
										<span v-if="!item.huan" style="color: #ffffff;">&nbsp;</span>
									</div>
									<div style="float: left;width: 35%;"
										:style="{ fontSize: (systemWidth * 0.018) + 'px', marginLeft: (systemWidth * 0.01) + 'px', }">
										<div style="font-weight: bold;float: left;"
											:style="{ fontSize: (systemWidth * 0.018) + 'px', lineHeight: (systemHeight * 0.06) + 'px', marginLeft: (systemWidth * 0.01) + 'px', marginRight: (systemWidth * 0.005) + 'px', }">
											<div style="color: #f19b54;" :style="{ fontSize: (systemWidth * 0.012) + 'px', }" v-if="item.fid">有修改
											</div>
											<div style="color: #f19b54;" :style="{ fontSize: (systemWidth * 0.012) + 'px', }"
												v-if="!item.fid && item.order_type == '白条录入'">白条录入</div>



											<!-- <div style="color: #f19b54;width: 2%;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;":style="{ fontSize:(systemWidth*0.012)+'px',}" v-if="item.notes">{{item.notes}}</div> -->
										</div>
										<div style="font-weight: bold;float: right;"
											:style="{ fontSize: (systemWidth * 0.018) + 'px', lineHeight: (systemHeight * 0.06) + 'px', marginLeft: (systemWidth * 0.01) + 'px', marginRight: (systemWidth * 0.001) + 'px', }">
											<span style="background-color: #e0665e;color: #ffffff;border-radius: 3px;"
												:style="{ fontSize: (systemWidth * 0.014) + 'px', marginLeft: (systemWidth * 0.01) + 'px', paddingLeft: (systemWidth * 0.005) + 'px', paddingRight: (systemWidth * 0.005) + 'px', paddingTop: (systemWidth * 0.003) + 'px', paddingBottom: (systemWidth * 0.003) + 'px' }"
												@click.stop="zuofeiOrder(item.id)" v-if="item.yourself">作废</span>
											 
										</div>
										<div style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis; width: 100%;"
											:style="{ fontSize: (systemWidth * 0.013) + 'px', marginLeft: (systemWidth * 0.01) + 'px', marginRight: (systemWidth * 0.005) + 'px', }">
											<span style="color: #9b9b9b;" v-if="item.user">
												开票员:{{ item.user.name }}&nbsp;&nbsp;{{ item.add_time }} </span>
											<span style="color: #52b460;float: right;"
												:style="{ fontSize: (systemWidth * 0.016) + 'px', marginRight: (systemWidth * 0.01) + 'px' }">查看</span>
										</div>
									</div>
								</div>
							</van-list>
						</van-pull-refresh>
					</el-scrollbar>
				</div>

			</div>

		</div>
		<!-- 分享 -->

		<!-- <el-dialog   :visible.sync="diashare" :width="(systemWidth * 0.3) + 'px'" center>
		     <div style="text-align: center;" :style="{ paddingTop: (systemHeight * 0.02) + 'px', paddingRight: (systemWidth * 0.03) + 'px' }">
						  <div style="margin-bottom: 20px;font-size:25px;font-weight: bold;">微信分享</div>
							<div style="margin-bottom: 10px;" @click="shareOrdering()"> <el-button type="primary" style="width: 80%;background-color: #409eff;">订单分享</el-button></div>
							<div style="margin-bottom: 10px;" @click="shareOrderImg()"> <el-button type="success" style="width: 80%;">订单图片分享</el-button></div>
							<div style="margin-bottom: 10px;" @click="shareOrdering()"> <el-button type="danger" style="width: 80%;">全部赊欠分享</el-button></div>
							<div style="margin-bottom: 10px;" @click="shareOrdering()"> <el-button type="warning" style="width: 80%;">全部订单分享</el-button></div> -->

		<!-- 		<div style="margin-bottom: 10px;" @click="shareOrdering()"> <el-button type="info" style="width: 80%;">订单分享</el-button></div>
							<div style="margin-bottom: 10px;" @click="shareOrderImg()"> <el-button type="success" style="width: 80%;">订单图片分享</el-button></div>
							<div style="margin-bottom: 10px;" @click="shareOrdering()"> <el-button type="info" style="width: 80%;">全部赊欠分享</el-button></div>
							<div style="margin-bottom: 10px;" @click="shareOrdering()"> <el-button type="info" style="width: 80%;">全部订单分享</el-button></div> -->


		<!-- <div style="margin-bottom: 10px;color:#ffffff"> 111</div>

		 </div>

		</el-dialog > -->
		<share :visible.sync="diashare" :order-id="shareOrderId" :order-item="shareOrderItem" :system-width="systemWidth"
			:system-height="systemHeight" @close="handleDialogClose" @image-shared="handleImageShared"
			@order-shared="handleOrderShared" />


		<el-drawer title="订单详情" :visible.sync="drawer" size="60%">
			<div style="background-color: #f4f5f7;user-select: none;">
				<div v-if="orderDetail.status != 0" style="background-color: #55ac7e;color: #ffffff;"
					:style="{ paddingLeft: (systemWidth * 0.015) + 'px', height: (systemHeight * 0.2) + 'px' }">
					<div :style="{ lineHeight: (systemHeight * 0.05) + 'px', fontSize: (systemWidth * 0.013) + 'px' }">票号
						{{ orderDetail.piao_num }} <span style="background-color: #ffffff;color: #d8a06e;">当班</span></div>
					<div style="font-weight: bold;" :style="{ lineHeight: (systemHeight * 0.04) + 'px', }">{{ orderDetail.maijia }}</div>
					<div :style="{ fontSize: (systemWidth * 0.012) + 'px' }">开单: {{ orderDetail.add_time }}</div>
					<span style="width: 100%; white-space: nowrap;overflow: hidden;text-overflow: ellipsis;"
						:style="{ fontSize: (systemWidth * 0.012) + 'px' }" v-if="orderDetail.notes">备注: {{ orderDetail.notes }}</span>
				</div>

				<div v-if="orderDetail.status == 0" style="background-color: #d85746;color: #ffffff;"
					:style="{ paddingLeft: (systemWidth * 0.015) + 'px', height: (systemHeight * 0.2) + 'px' }">
					<div :style="{ lineHeight: (systemHeight * 0.05) + 'px', fontSize: (systemWidth * 0.013) + 'px' }">票号
						{{ orderDetail.piao_num }} <span style="background-color: #ffffff;color: #d8a06e;">当班</span></div>
					<div style="font-weight: bold;" :style="{ lineHeight: (systemHeight * 0.05) + 'px', }">{{ orderDetail.maijia }}</div>
					<div :style="{ fontSize: (systemWidth * 0.012) + 'px' }">开单 {{ orderDetail.add_time }}</div>
				</div>

				<div style="background-color: #ffffff;width: 90%;border-radius:10px;margin-left: 5%;"
					:style="{ height: (systemHeight * 0.10) + 'px', paddingLeft: (systemWidth * 0.01) + 'px', marginTop: -(systemHeight * 0.05) + 'px', }">
					<div v-if="orderDetail.status != 0" style="color: #54ab7b;font-weight: bold;"
						:style="{ lineHeight: (systemHeight * 0.06) + 'px', fontSize: (systemWidth * 0.015) + 'px', }">已结清</div>
					<div v-if="orderDetail.status == 0" style="color: #d85746 ;font-weight: bold;"
						:style="{ lineHeight: (systemHeight * 0.06) + 'px', fontSize: (systemWidth * 0.015) + 'px', }">赊欠</div>
					<div style="font-weight: bold;" :style="{ lineHeight: (systemHeight * 0.04) + 'px', }">
						<span style="color: #737373;">订单</span>
						<span>{{ orderDetail.total_price }}</span>
						<span style="color: #737373;" v-if="orderDetail.status != 0">已付</span>
						<span v-if="orderDetail.status != 0">{{ orderDetail.shishou }}</span>
						<span v-if="orderDetail.duoshou">(<span style="color: #737373;">多收</span>{{ orderDetail.duoshou }})</span>
						<span v-if="orderDetail.youhui">(<span style="color: #737373;">优惠</span>{{ orderDetail.youhui }})</span>
					</div>
				</div>
				<div style="font-weight: bold;border-bottom: 1px solid #9a9a9a;background-color: #ffffff;"
					:style="{ paddingLeft: (systemWidth * 0.013) + 'px', marginTop: (systemHeight * 0.01) + 'px', lineHeight: (systemHeight * 0.06) + 'px', fontSize: (systemWidth * 0.015) + 'px', }">
					货品明细</div>

				<div v-if="orderDetail.order_type == '白条录入'" style="text-align: center;">
					<el-image style="width: 50%; height: 50%;" :src="orderDetail.imageUrl" fit="contain"
						:preview-src-list="[orderDetail.imageUrl]"></el-image>
				</div>

				<div v-if="orderDetail.order_type != '白条录入'"
					style="background-color: ;;border-bottom: 1px solid #9a9a9a;background-color: #ffffff;" :style="{
						height: (systemHeight * 0.04) + 'px',
						fontSize: (systemWidth * 0.013) + 'px',
						paddingLeft: (systemWidth * 0.013) + 'px',
						lineHeight: (systemHeight * 0.04) + 'px',
					}">
					<div style="color: #9a9a9a; width: 20%;float: left;">货品/批次号</div>
					<div style="color: #9a9a9a; width: 20%;float: left;text-align: center;">数量/重量</div>
					<div style="color: #9a9a9a; width: 20%;float: left;text-align: center;">单价</div>
					<div style="color: #9a9a9a; width: 20%;float: left;text-align: center;">货款</div>
					<div style="color: #9a9a9a; width: 20%;float: left;text-align: center;">操作</div>

				</div>
				<el-scrollbar :style="{ height: (systemHeight * 0.4) + 'px' }">
					<div v-for="(itemDetail, index) in orderDetail.order_detail"
						style="background-color: #ffffff;border-bottom: 1px"
						:style="{ paddingLeft: (systemWidth * 0.013) + 'px', fontSize: (systemWidth * 0.013) + 'px', height: (systemHeight * 0.13) + 'px', marginBottom: (systemHeight * 0.008) + 'px' }">
						<div style="width: 100%;">
							<div style="width: 100%;font-weight: bold;"
								:style="{ height: (systemHeight * 0.06) + 'px', lineHeight: (systemHeight * 0.06) + 'px' }">
								<!-- <span>{{index+1}}.</span>{{itemDetail.goods_name}} -->
								<div
									style="width: 20%;float: left;text-align: left;font-weight: bold;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">
									{{ index + 1 }}.{{ itemDetail.goods_name }}</div>
								<div
									style="width: 20%;float: left;text-align: center;font-weight: bold;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">

									<span v-if="itemDetail.num && itemDetail.weight">
										<span v-if="itemDetail.unit == '公斤' || itemDetail.unit == '斤'">
											{{ itemDetail.num }}件/({{ itemDetail.weight }}{{ itemDetail.unit }})</span>
										<span v-else> {{ itemDetail.num }}{{ itemDetail.unit }}/({{ itemDetail.weight }}公斤)</span>
									</span>
									<span v-else>
										<!--      <span>{{itemDetail.num}} {{itemDetail.unit}}</span> -->
										<span v-if="itemDetail.unit == '公斤' || itemDetail.unit == '斤'">
											{{ itemDetail.weight }}{{ itemDetail.unit }}</span>
										<span v-else> {{ itemDetail.num }}{{ itemDetail.unit }}</span>
										<!-- <span v-if="itemDetail.num"> {{itemDetail.num}} {{itemDetail.unit}}</span> -->
										<!-- <span v-if="itemDetail.weight"> {{itemDetail.weight}}{{itemDetail.unit}}</span> -->
									</span>
								</div>
								<div
									style="width: 20%;float: left;text-align: center;font-weight: bold;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">

									<span v-if="itemDetail.huozhu_num > 0">(包)</span>
									{{ itemDetail.price }}/{{ itemDetail.unit }}

								</div>
								<div
									style="width: 20%;float: left;text-align: center;font-weight: bold;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">
									{{ itemDetail.goods_price }}</div>
								<div
									style="width: 20%;float: left;text-align: center;font-weight: bold;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">
									<i @click="printDetail(itemDetail)" class="el-icon-printer">打印</i></div>
							</div>
							<div style="width: 100%;font-weight: bold;color: #989ea7;"
								:style="{ height: (systemHeight * 0.02) + 'px', lineHeight: (systemHeight * 0.01) + 'px', marginTop: (systemHeight * (-0.00)) + 'px' }">
								<div
									style="width: 20%;float: left;text-align: left;font-weight: bold;margin-top:-10px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">
									<el-tag v-for="(itemGuige, index) in itemDetail.goods.goods_guige" :key="index" size="mini"
										type="success" :effect="'plain'" v-if="itemDetail.goods.goods_guige.length > 0">
										<span>
											1{{ itemGuige.relation }}={{ itemGuige.num }}{{ itemGuige.unit }}
										</span>
									</el-tag>
									<el-tag size="mini" type="success" :effect="'plain'" v-if="itemDetail.goods.goods_guige == 0">
										<span>无定装按{{ itemDetail.unit }}卖</span>
									</el-tag>
								</div>
							</div>
							<div style="clear:both"></div>

							<div style="width: 100%;font-weight: bold;color: #989ea7;"
								:style="{ height: (systemHeight * 0.05) + 'px', lineHeight: (systemHeight * 0.05) + 'px' }">
								<div style="width: 20%;float: left;text-align: left;font-weight: bold;">
									<span
										v-if="itemDetail.order_detail_pici">{{ itemDetail.order_detail_pici.huozhu_name }}&nbsp;{{ itemDetail.order_detail_pici.pici }}</span>
								</div>
								<div style="width: 60%;float: left;text-align: center;font-weight: bold;">
									<span style="color:#ffffff">1</span>
									<span v-if="itemDetail.order_detail_fujiafei.length > 0">附加费:</span>
									<span v-if="itemDetail.order_detail_fujiafei"
										v-for="(itemDetailFujiafei, index) in itemDetail.order_detail_fujiafei">
										{{ itemDetailFujiafei.name }}:{{ itemDetailFujiafei.total }}元&nbsp;
									</span>
								</div>

								<div style="width: 20%;float: left;text-align: center;font-weight: bold;color: red;">
									小计:{{ itemDetail.total_price }}</div>
							</div>
							<!-- <div style="color: #606060;" :style="{fontSize:(systemWidth*0.010)+'px', lineHeight:(systemHeight*0.04)+'px' }">{{itemDetail.pici}}</div> -->
						</div>
					</div>
					<div style="clear: both;"></div>
					<!-- <div style="background-color: #ffffff;":style="{fontSize:(systemWidth*0.012)+'px', height:(systemHeight*0.08)+'px',paddingLeft:(systemWidth*0.013)+'px',lineHeight:(systemHeight*0.06)+'px',}">
                  <div style="width: 22%;float: left">
                     <div style="color: #606060;":style="{lineHeight:(systemHeight*0.04)+'px'}"> 收银员:{{orderDetail.user.name}}</div>
                     <div style="color: #606060;" :style="{lineHeight:(systemHeight*0.04)+'px'}">开票员:{{orderDetail.user.name}} </div>
                  </div>
              </div> -->
					<div style="background-color: #ffffff;"
						:style="{ fontSize: (systemWidth * 0.012) + 'px', marginTop: (systemHeight * 0.01) + 'px', paddingLeft: (systemWidth * 0.013) + 'px', lineHeight: (systemHeight * 0.06) + 'px', }">
						<div style="">
							<div style="font-weight: bold;;" :style="{ lineHeight: (systemHeight * 0.04) + 'px' }">订单的一生</div>
							<!-- <div style="font-weight: bold;color: #989ea7;" :style="{lineHeight:(systemHeight*0.04)+'px', paddingLeft:(systemWidth*0.02)+'px',}">
                       <div>
                            <div style="float: left; background-color: #54ab7b;color: #ffffff;border-radius: 5px;text-align: center;" :style="{ width:(systemWidth*0.025)+'px', marginLeft:(systemWidth*(-0.03))+'px',}">{{record.length+1}}</div>
                            <span   :style="{fontSize:(systemWidth*0.016)+'px'}" style="color:#54ab7b;font-weight: bold;"v-if="orderDetail.status!=0">当前订单:已付款</span>
                           <span  :style="{fontSize:(systemWidth*0.016)+'px'}"  style="color:#d85746;font-weight: bold;" v-if="orderDetail.status==0">当前订单:赊欠</span>
                           :{{orderDetail.add_time}}
                        </div>
                       <div v-if="orderDetail.user">操作人员:{{orderDetail.user.name}}</div>
                       <div>应收:{{orderDetail.total_price}}元</div>
                       <div  v-if="orderDetail.status!=0">实收:{{orderDetail.total_price}}元</div>
                       <div  v-if="orderDetail.status==0">下欠:{{orderDetail.total_price}}元</div>
                       <div  v-if="orderDetail.status!=0">支付方式:
                           <span v-if="orderDetail.cash_num>0">现金{{orderDetail.cash_num}}元</span>
                           <span v-if="orderDetail.wepay_num>0">微信{{orderDetail.wepay_num}}元</span>
                           <span v-if="orderDetail.alipay_num>0">支付宝{{orderDetail.alipay_num}}元</span>
                           <span v-if="orderDetail.union_num>0">银联{{orderDetail.union_num}}元</span>
                           <span v-if="orderDetail.other_num>0">其他{{orderDetail.other_num}}元</span>
                       </div>
                     </div> -->

							<div <div v-for="(item, index) in record" style="font-weight: bold;color: #989ea7;"
								:style="{ lineHeight: (systemHeight * 0.04) + 'px', paddingLeft: (systemWidth * 0.02) + 'px', }">
								<div v-if="index == 0 && orderDetail.zuofei != 1">
									<div
										style="float: left; background-color: #54ab7b;color: #ffffff;border-radius: 5px;text-align: center;"
										:style="{ width: (systemWidth * 0.025) + 'px', marginLeft: (systemWidth * (-0.03)) + 'px', }">
										{{ record.length - index }}</div>
									<span :style="{ fontSize: (systemWidth * 0.016) + 'px' }" style="color:#54ab7b;font-weight: bold;"
										v-if="item.type == 1">开单收银</span>
									<span :style="{ fontSize: (systemWidth * 0.016) + 'px' }" style="color:#d85746;font-weight: bold;"
										v-if="item.type == 2">开单赊欠</span>
									<span :style="{ fontSize: (systemWidth * 0.016) + 'px' }" style="color:#d85746;font-weight: bold;"
										v-if="item.type == 22">白条赊欠</span>
									<span :style="{ fontSize: (systemWidth * 0.016) + 'px' }" style="color:#54ab7b;font-weight: bold;"
										v-if="item.type == 3">作废订单</span>
									<span :style="{ fontSize: (systemWidth * 0.016) + 'px' }" style="color:#54ab7b;font-weight: bold;"
										v-if="item.type == 4">恢复订单</span>
									<span :style="{ fontSize: (systemWidth * 0.016) + 'px' }" style="color:#54ab7b;font-weight: bold;"
										v-if="item.type == 5">操作还款</span>
									<span :style="{ fontSize: (systemWidth * 0.016) + 'px' }" style="color:#54ab7b;font-weight: bold;"
										v-if="item.type == 6">撤销还款</span>
									<span :style="{ fontSize: (systemWidth * 0.016) + 'px' }" style="color:#54ab7b;font-weight: bold;"
										v-if="item.type == 7">改单</span>
									:{{ item.time }}
								</div>
								<div v-if="index != 0 || orderDetail.zuofei == 1">
									<div
										style="float: left; background-color: #989ea7;color: #ffffff;border-radius: 5px;text-align: center;"
										:style="{ width: (systemWidth * 0.025) + 'px', marginLeft: (systemWidth * (-0.03)) + 'px', }">
										{{ record.length - index }}</div>
									<span :style="{ fontSize: (systemWidth * 0.016) + 'px' }" style="color:#989ea7;font-weight: bold;"
										v-if="item.type == 1">开单收银</span>
									<span :style="{ fontSize: (systemWidth * 0.016) + 'px' }" style="color:#989ea7;font-weight: bold;"
										v-if="item.type == 2">开单赊欠</span>
									<span :style="{ fontSize: (systemWidth * 0.016) + 'px' }" style="color:#989ea7;font-weight: bold;"
										v-if="item.type == 22">白条赊欠</span>
									<span :style="{ fontSize: (systemWidth * 0.016) + 'px' }" style="color:#989ea7;font-weight: bold;"
										v-if="item.type == 3">作废订单</span>
									<span :style="{ fontSize: (systemWidth * 0.016) + 'px' }" style="color:#989ea7;font-weight: bold;"
										v-if="item.type == 4">恢复订单</span>
									<span :style="{ fontSize: (systemWidth * 0.016) + 'px' }" style="color:#989ea7;font-weight: bold;"
										v-if="item.type == 5">操作还款</span>
									<span :style="{ fontSize: (systemWidth * 0.016) + 'px' }" style="color:#989ea7;font-weight: bold;"
										v-if="item.type == 6">撤销还款</span>
									<span :style="{ fontSize: (systemWidth * 0.016) + 'px' }" style="color:#989ea7;font-weight: bold;"
										v-if="item.type == 7">改单</span>
									:{{ item.time }}
								</div>
								<div v-if="item.user">操作人员:{{ item.user.name }}</div>
								<div v-if="item.type == 1 || item.type == 2 || item.type == 4 || item.type == 7">
									<div>应收:{{ item.total_price }}元</div>
									<div v-if="item.status != 0">实收:{{ item.shishou }}元 <span
											v-if="item.duoshou > 0">(多收{{ item.duoshou }}元)</span><span
											v-if="item.youhui > 0">(优惠{{ item.youhui }}元)</span></div>
									<div v-if="item.status == 0">下欠:{{ item.yingshou }}元 <span
											v-if="item.duoshou > 0">(多收{{ item.duoshou }}元)</span><span
											v-if="item.youhui > 0">(优惠{{ item.youhui }}元)</span></div>
									<div v-if="item.status != 0">支付方式:
										<span v-if="item.cash_num > 0">现金{{ item.cash_num }}元</span>
										<span v-if="item.wepay_num > 0">微信{{ item.wepay_num }}元</span>
										<span v-if="item.alipay_num > 0">支付宝{{ item.alipay_num }}元</span>
										<span v-if="item.union_num > 0">银联{{ item.union_num }}元</span>
										<span v-if="item.other_num > 0">其他{{ item.other_num }}元</span>
									</div>
									<div v-if="item.type == 7" style="color:#54ab7b ;" @click="getZuofeiOrderDetail(item.order_id)">
										查看改前订单<i class="el-icon-arrow-right"></i>
									</div>
								</div>
								<div v-if="item.type == 3">
									<div>作废金额:{{ item.total_price }}元</div>
								</div>
								<div v-if="item.type == 22">
									<div>赊欠金额:{{ item.total_price }}元</div>
								</div>
								<div v-if="item.type == 5">
									<div>还款金额:<span v-if="item.cash_num > 0">现金{{ item.cash_num }}元</span>
										<span v-if="item.wepay_num > 0">微信{{ item.wepay_num }}元</span>
										<span v-if="item.alipay_num > 0">支付宝{{ item.alipay_num }}元</span>
										<span v-if="item.union_num > 0">银联{{ item.union_num }}元</span>
										<span v-if="item.other_num > 0">其他{{ item.other_num }}元</span>
									</div>
								</div>
							</div>
						</div>
					</div>

				</el-scrollbar>
				<div v-if="orderDetail.status == 1 && !orderDetail.huankuan"
					style="position: absolute;width: 100%;bottom: 0;background-color: #ffffff;"
					:style="{ lineHeight: (systemHeight * 0.07) + 'px', marginBottom: (systemHeight * 0.01) + 'px', fontSize: (systemWidth * 0.015) + 'px', }">
					<div v-if="orderDetail.yourself"
						style="float: left; width: 48%;text-align: center;color: red;: 5px;margin-left:1%;margin-right:1%;border: 1px solid red;border-radius: 5px;font-weight: bold;"
						@click="zuofeiOrder(orderDetail.id)">作废</div>
					<div v-if="orderDetail.yourself && orderDetail.order_type != '白条录入'"
						style="float: left;width: 48%;text-align: center; border-radius: 5px;border: 1px solid #e0e0e0;border-radius: 5px;font-weight: bold;"
						@click="updateOrder(orderDetail.id)">改单</div>
				</div>
				<div v-if="orderDetail.status == 0 || orderDetail.huankuan"
					style="position: absolute;width: 100%;bottom: 0;background-color: #ffffff;"
					:style="{ lineHeight: (systemHeight * 0.07) + 'px', marginBottom: (systemHeight * 0.01) + 'px', fontSize: (systemWidth * 0.015) + 'px', }">
					<div v-if="orderDetail.status == 0"
						style="float: left; width: 30%;text-align: center;color: #4ca75b;: 5px;margin-left:1%;margin-right:1%;border: 1px solid #4ca75b;border-radius: 5px;font-weight: bold;"
						@click="huankuanOrder(orderDetail)">操作还款</div>
					<div v-if="orderDetail.huankuan"
						style="float: left; width: 30%;text-align: center;color: red;: 5px;margin-left:1%;margin-right:1%;border: 1px solid red;border-radius: 5px;font-weight: bold;"
						@click="zuofeiOrder(orderDetail.id)"> 撤销还款</div>
					<div v-if="orderDetail.yourself"
						style="float: left; width: 30%;text-align: center;color: red;: 5px;margin-left:1%;margin-right:1%;border: 1px solid red;border-radius: 5px;font-weight: bold;"
						@click="zuofeiOrder(orderDetail.id)">作废</div>
					<div v-if="orderDetail.yourself && orderDetail.order_type != '白条录入'"
						style="float: left;width: 30%;text-align: center; border-radius: 5px;border: 1px solid #e0e0e0;border-radius: 5px;font-weight: bold;"
						@click="updateOrder(orderDetail.id)">改单</div>
				</div>
			</div>
		</el-drawer>

		<el-drawer title="修改详情" :visible.sync="dialogTableVisible" size="60%">
			<div style="background-color: #f4f5f7;user-select: none;">
				<div style="background-color: #989ea7;color: #ffffff;"
					:style="{ paddingLeft: (systemWidth * 0.015) + 'px', height: (systemHeight * 0.2) + 'px' }">
					<div :style="{ lineHeight: (systemHeight * 0.05) + 'px', fontSize: (systemWidth * 0.013) + 'px' }">票号
						{{ zuofeirecordDetail.piao_num }} <span style="background-color: #ffffff;color: #d8a06e;">当班</span></div>
					<div style="font-weight: bold;" :style="{ lineHeight: (systemHeight * 0.05) + 'px', }">{{ zuofeirecordDetail.maijia }}
					</div>
					<div :style="{ fontSize: (systemWidth * 0.012) + 'px' }">开单: {{ orderDetail.add_time }}</div>
					<div style="width: 100%; white-space: nowrap;overflow: hidden;text-overflow: ellipsis;"
						:style="{ fontSize: (systemWidth * 0.012) + 'px' }" v-if="zuofeirecordDetail.notes">备注:
						{{ zuofeirecordDetail.notes }}</div>
				</div>



				<div style="background-color: #ffffff;width: 90%;border-radius:10px;margin-left: 5%;"
					:style="{ height: (systemHeight * 0.10) + 'px', paddingLeft: (systemWidth * 0.01) + 'px', marginTop: -(systemHeight * 0.05) + 'px', }">
					<div style="color: #d85746 ;font-weight: bold;"
						:style="{ lineHeight: (systemHeight * 0.06) + 'px', fontSize: (systemWidth * 0.015) + 'px', }">已作废</div>
					<div style="font-weight: bold;" :style="{ lineHeight: (systemHeight * 0.04) + 'px', }">
						<span style="color: #737373;">订单</span>
						<span>{{ zuofeirecordDetail.total_price }}</span>
						<!-- <span style="color: #737373;"   v-if="zuofeirecordDetail.status!=0" >已付</span>
                          <span  v-if="zuofeirecordDetail.status!=0" >{{zuofeirecordDetail.total_price}}</span> -->
					</div>
				</div>
				<div style="font-weight: bold;border-bottom: 1px solid #9a9a9a;background-color: #ffffff;"
					:style="{ paddingLeft: (systemWidth * 0.013) + 'px', marginTop: (systemHeight * 0.01) + 'px', lineHeight: (systemHeight * 0.06) + 'px', fontSize: (systemWidth * 0.015) + 'px', }">
					货品明细</div>
				<div style="background-color: ;;border-bottom: 1px solid #9a9a9a;background-color: #ffffff;" :style="{
					height: (systemHeight * 0.04) + 'px',
					fontSize: (systemWidth * 0.013) + 'px',
					paddingLeft: (systemWidth * 0.013) + 'px',
					lineHeight: (systemHeight * 0.04) + 'px',
				}">
					<div style="color: #9a9a9a; width: 25%;float: left;">货品/批次号</div>
					<div style="color: #9a9a9a; width: 25%;float: left;text-align: center;">数量/重量</div>
					<div style="color: #9a9a9a; width: 25%;float: left;text-align: center;">单价</div>
					<div style="color: #9a9a9a; width: 25%;float: left;text-align: center;">货款</div>
					<!-- <div style="color: #9a9a9a; width: 20%;float: left;text-align: center;">操作</div> -->

				</div>
				<el-scrollbar :style="{ height: (systemHeight * 0.5) + 'px' }">
					<div v-for="(itemDetail, index) in zuofeirecordDetail.order_detail"
						style="background-color: #ffffff;border-bottom: 1px"
						:style="{ paddingLeft: (systemWidth * 0.013) + 'px', fontSize: (systemWidth * 0.015) + 'px', height: (systemHeight * 0.13) + 'px', marginBottom: (systemHeight * 0.008) + 'px' }">
						<div style="width: 100%;">
							<div style="width: 100%;font-weight: bold;"
								:style="{ height: (systemHeight * 0.06) + 'px', lineHeight: (systemHeight * 0.06) + 'px' }">
								<!-- <span>{{index+1}}.</span>{{itemDetail.goods_name}} -->
								<div
									style="width: 25%;float: left;text-align: left;font-weight: bold;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">
									{{ index + 1 }}.{{ itemDetail.goods_name }}</div>
								<div
									style="width: 25%;float: left;text-align: center;font-weight: bold;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">
									<span v-if="itemDetail.num && itemDetail.weight">
										<span v-if="itemDetail.unit == '公斤'"> {{ itemDetail.num }}件/({{ itemDetail.weight }}公斤)</span>
										<span v-if="itemDetail.unit != '公斤'">
											{{ itemDetail.num }}{{ itemDetail.unit }}/({{ itemDetail.weight }}公斤)</span>
									</span>
									<span v-else>
										<span v-if="itemDetail.num"> {{ itemDetail.num }} {{ itemDetail.unit }}</span>
										<span v-if="itemDetail.weight"> {{ itemDetail.weight }}{{ itemDetail.unit }}</span>
									</span>
								</div>
								<div
									style="width: 25%;float: left;text-align: center;font-weight: bold;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">
									{{ itemDetail.price }}</div>
								<div
									style="width: 25%;float: left;text-align: center;font-weight: bold;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">
									{{ itemDetail.goods_price }}</div>
							</div>
							<div style="width: 100%;font-weight: bold;color: #989ea7;"
								:style="{ height: (systemHeight * 0.02) + 'px', lineHeight: (systemHeight * 0.01) + 'px', marginTop: (systemHeight * (-0.00)) + 'px' }">
								<div style="width: 20%;float: left;text-align: left;font-weight: bold;margin-top:-10px">
									<el-tag v-for="(itemGuige, index) in itemDetail.goods.goods_guige" :key="index" size="mini"
										type="success" :effect="'plain'" v-if="itemDetail.goods.goods_guige.length > 0">
										<span>
											1{{ itemGuige.relation }}={{ itemGuige.num }}{{ itemGuige.unit }}
										</span>
									</el-tag>
									<el-tag size="mini" type="success" :effect="'plain'" v-if="itemDetail.goods.goods_guige == 0">
										<span>无定装按{{ itemDetail.unit }}卖</span>
									</el-tag>
								</div>
							</div>
							<div style="width: 100%;font-weight: bold;color: #989ea7;"
								:style="{ height: (systemHeight * 0.05) + 'px', lineHeight: (systemHeight * 0.05) + 'px' }">
								<div style="width: 20%;float: left;text-align: left;font-weight: bold;">
									<span
										v-if="itemDetail.order_detail_pici">{{ itemDetail.order_detail_pici.huozhu_name }}&nbsp;{{ itemDetail.order_detail_pici.pici }}</span>
								</div>
								<div style="width: 60%;float: left;text-align: center;font-weight: bold;">
									<!-- (附加费: <span v-if="itemDetail.order_detail_fujiafei"  v-for="(itemDetailFujiafei,index) in itemDetail.order_detail_fujiafei">{{itemDetailFujiafei.name}}:{{itemDetailFujiafei.total}}元&nbsp;</span>) -->
									<span style="color:#ffffff">1</span>
									<span v-if="itemDetail.order_detail_fujiafei"
										v-for="(itemDetailFujiafei, index) in itemDetail.order_detail_fujiafei">(附加费:
										{{ itemDetailFujiafei.name }}:{{ itemDetailFujiafei.total }}元)&nbsp;</span>
								</div>

								<div style="width: 20%;float: left;text-align: center;font-weight: bold;color: red;">
									小计:{{ itemDetail.total_price }}</div>
							</div>
							<!-- <div style="color: #606060;" :style="{fontSize:(systemWidth*0.010)+'px', lineHeight:(systemHeight*0.04)+'px' }">{{itemDetail.pici}}</div> -->
						</div>
					</div>
				</el-scrollbar>

			</div>
		</el-drawer>



		<el-dialog width="60%" title="" :visible.sync="shouyinDrawer" direction="rtl">
			<div :style="{ height: (systemHeight * 0.75) + 'px' }" class="settlement" v-loading="shouyinloading">
				<div style="width:100%;background-color: ;" :style="{ height: (systemHeight * 0.07) + 'px' }">
					<div style="float: left;width: 30%;color: #c86153;font-weight: bold;"
						:style="{ fontSize: (systemWidth * 0.02) + 'px' }">
						{{ orderDetail.maijia }}
					</div>

				</div>
				<div :style="{ height: (systemHeight * 0.1) + 'px', marginTop: (systemHeight * 0.01) + 'px' }">
					<div style="background-color: #deddde; float: left;width: 100%;border-radius: 5px;">
						<div style="float:left;width: 40%;" :style="{
							height: systemHeight * 0.08 + 'px',
							lineHeight: systemHeight * 0.08 + 'px'
						}">
							<span :style="{
								fontSize: systemWidth * 0.018 + 'px'
							}">应收</span>

							<span style="font-weight: bold;" :style="{ fontSize: systemWidth * 0.02 + 'px' }">{{
								settlement.yingshou }}</span>
						</div>

						<div style="float:left;width: 55%;"
							:style="{ height: systemHeight * 0.08 + 'px', lineHeight: systemHeight * 0.08 + 'px' }">
							<div class="switch-and-delete-container" style="width: 20%;float: left;">

								<div :style="{ height: systemHeight * 0.045 + 'px', marginTop: systemHeight * 0.02 + 'px', }"
									class="custom-switch" :class="{ 'active': settlement.value === 1, 'inactive': settlement.value === 0 }"
									@click="toggleStatus(settlement.value)">
									<span class="switch-option stop-sale">
										优惠
									</span>
									<span class="switch-option on-sale">
										多收
									</span>
								</div>
							</div>

							<div style="float: right;width: 50%;font-weight: bold;">
								<el-input readonly :placeholder="settlement.placeholder" v-model="settlement.input_num"
									@focus="changeSettlementFocusType('num')" @input="changeSettlementInput">
									<template slot="append">元</template>
								</el-input>
							</div>

						</div>
					</div>
				</div>
				<div :style="{ height: (systemHeight * 0.15) + 'px', marginTop: (systemHeight * 0.01) + 'px' }">
					<div style="background-color: #ffffff; float: left;width: 55%;">
						<div :style="{ height: (systemHeight * 0.06) + 'px', lineHeight: (systemHeight * 0.06) + 'px', }">
							<div style="width: 50%;float: left;">
								<span :style="{ fontSize: (systemWidth * 0.012) + 'px' }">合计</span>
								<span style="font-weight: bold;" :style="{ fontSize: (systemWidth * 0.02) + 'px' }">{{ settlement.heji }}</span>
							</div>

						</div>

						<div :style="{ height: (systemHeight * 0.06) + 'px', lineHeight: (systemHeight * 0.06) + 'px', }">
							<div style="width: 100%;float: left;">
								<span :style="{ fontSize: (systemWidth * 0.012) + 'px' }">实收</span>
								<span style="font-weight: bold;color: #d58842;"
									:style="{ fontSize: (systemWidth * 0.02) + 'px' }">{{ settlement.shishou }}</span>
							</div>
						</div>

					</div>
					<div style="background-color: ; float: right;">
						<div :style="{ height: (systemHeight * 0.15) + 'px', lineHeight: (systemHeight * 0.1) + 'px', }">
							<el-input type="textarea" placeholder="付款备注" v-model="notes" show-word-limit>
							</el-input>
						</div>
					</div>
				</div>
				<div>
					<div style="float: left;width: 38%;margin-right: 1%;"
						:style="{ fontSize: (systemWidth * 0.015) + 'px', height: (systemHeight * 0.4) + 'px' }">
						<div @click="chooseIndexPayType(1)" style="background-color: #cccacc;border-radius: 2px;"
							:class="kayboardPayTypeChooseIndex == 1 ? 'chooseBtn' : 'btn'"
							:style="{ marginBottom: (systemHeight * 0.01) + 'px', height: (systemHeight * 0.07) + 'px', paddingLeft: (systemWidth * 0.01) + 'px', lineHeight: (systemHeight * 0.07) + 'px', }">
							<img style="float: left;"
								:style="{ height: (systemHeight * 0.05) + 'px', marginTop: (systemHeight * 0.01) + 'px', marginRight: (systemHeight * 0.02) + 'px' }"
								src="../assets/img/cash.png" alt="" />
							<div style="float: left;"> 现金</div>
							<div style="float: right;font-weight: bold;" :style="{ marginRight: (systemWidth * 0.01) + 'px' }">
								{{ settlement.cash_num }} </div>
						</div>
						<div @click="chooseIndexPayType(2)" style="background-color: #cccacc;border-radius: 2px;"
							:class="kayboardPayTypeChooseIndex == 2 ? 'chooseBtn' : 'btn'"
							:style="{ marginBottom: (systemHeight * 0.01) + 'px', height: (systemHeight * 0.07) + 'px', paddingLeft: (systemWidth * 0.01) + 'px', lineHeight: (systemHeight * 0.07) + 'px', }">
							<img style="float: left;"
								:style="{ height: (systemHeight * 0.05) + 'px', marginTop: (systemHeight * 0.01) + 'px', marginRight: (systemHeight * 0.02) + 'px' }"
								src="../assets/img/wepay.png" alt="" />
							<div style="float: left;"> 微信</div>
							<div style="float: right;font-weight: bold;" :style="{ marginRight: (systemWidth * 0.01) + 'px' }">
								{{ settlement.wepay_num }} </div>
						</div>
						<div @click="chooseIndexPayType(3)" style="background-color: #cccacc;border-radius: 2px;"
							:class="kayboardPayTypeChooseIndex == 3 ? 'chooseBtn' : 'btn'"
							:style="{ marginBottom: (systemHeight * 0.01) + 'px', height: (systemHeight * 0.07) + 'px', paddingLeft: (systemWidth * 0.01) + 'px', lineHeight: (systemHeight * 0.07) + 'px', }">
							<img style="float: left;"
								:style="{ height: (systemHeight * 0.05) + 'px', marginTop: (systemHeight * 0.01) + 'px', marginRight: (systemHeight * 0.02) + 'px' }"
								src="../assets/img/alipay.png" alt="" />
							<div style="float: left;"> 支付宝</div>
							<div style="float: right;font-weight: bold;" :style="{ marginRight: (systemWidth * 0.01) + 'px' }">
								{{ settlement.alipay_num }} </div>
						</div>
						<div @click="chooseIndexPayType(4)" style="background-color: #cccacc;border-radius: 2px;"
							:class="kayboardPayTypeChooseIndex == 4 ? 'chooseBtn' : 'btn'"
							:style="{ marginBottom: (systemHeight * 0.01) + 'px', height: (systemHeight * 0.07) + 'px', paddingLeft: (systemWidth * 0.01) + 'px', lineHeight: (systemHeight * 0.07) + 'px', }">
							<img style="float: left;"
								:style="{ height: (systemHeight * 0.05) + 'px', marginTop: (systemHeight * 0.01) + 'px', marginRight: (systemHeight * 0.02) + 'px' }"
								src="../assets/img/union.png" alt="" />
							<div style="float: left;"> 银联</div>
							<div style="float: right;font-weight: bold;" :style="{ marginRight: (systemWidth * 0.01) + 'px' }">
								{{ settlement.union_num }} </div>
						</div>
						<div @click="chooseIndexPayType(5)" style="background-color: #cccacc;border-radius: 2px;"
							:class="kayboardPayTypeChooseIndex == 5 ? 'chooseBtn' : 'btn'"
							:style="{ marginBottom: (systemHeight * 0.01) + 'px', height: (systemHeight * 0.07) + 'px', paddingLeft: (systemWidth * 0.01) + 'px', lineHeight: (systemHeight * 0.07) + 'px', }">
							<img style="float: left;"
								:style="{ height: (systemHeight * 0.05) + 'px', marginTop: (systemHeight * 0.01) + 'px', marginRight: (systemHeight * 0.02) + 'px' }"
								src="../assets/img/other.png" alt="" />
							<div style="float: left;"> 其他</div>
							<div style="float: right;font-weight: bold;" :style="{ marginRight: (systemWidth * 0.01) + 'px' }">
								{{ settlement.other_num }} </div>
						</div>
					</div>
					<div class="keyboardsettlement" style="width: 60%;float: right;">
						<ul
							:style="{ height: (systemHeight * 0.4) + 'px', columnGap: (systemWidth * 0.005) + 'px', rowGap: (systemHeight * 0.005) + 'px' }"
							style="">
							<li :style="{ fontSize: (systemWidth * 0.02) + 'px' }" v-for="(item, index) in kayboardArrsettlement"
								@click="keyboardClick(item)" :key="index"
								:class="{ keyboardNum: item != '收银' && item != '删除' && item != '赊账', keyboardConfirm: item == '收银', keyboardDel: item == '删除', keyboardOncredit: item == '赊账' }">
								{{ item }}
							</li>
						</ul>
					</div>
				</div>
			</div>
		</el-dialog>




	</div>







	</div>
</template>

<script>
import {
	orderGetPrintOrder,
	sprt_printer,
	sprt_printer2,
	generatePrintContent3,
	generatePrintContent4,
	executePrint,
	generateQRCode,
	makebase64QRCode,
	getOrderData,
	updateOrderData,
	getZuofeiOrderDetailData,
	zuofeiOrderData,
	getOrderDetailData,
	getColorConfig,
	huankuanData,
	orderListPrint
} from "../api/index";
import domToImage from "dom-to-image";
import html2canvas from "html2canvas";
import { Loading } from "element-ui";
import JsBridge from 'jsbridge';
// import jsBridge from 'ym-jsbridge'

import * as tools from '@/utils/tools.js';
import { tiaoma } from "@/utils/dataJSon.js";
import { getReceiptField, test64 } from "@/api/system-set";
import dayjs from "dayjs";
import JsBarcode from "jsbarcode";

import share from "./set/components/share.vue";
// console.log('dayjs',dayjs);
// let td = dayjs().format('YYYY-MM-DD HH:mm:ss')
// console.log(td)
// 整体订单：0：待付款  1：完成   2：部分退款   3：全额退款   4：取消 5：关闭订单 6：支付失败
//订单中单个商品：0：待付款  1：完成   2：退款中  3：退款完成   4：订单取消  5：关闭订单
export default {
	components: {
		share
	},
	data() {
		return {
			diashare: false,
			shareOrderId: "",
			shareOrderItem: "",
			finalmoney: 0,
			showPrint: false,
			checkedColor: "#000", // 选中时的颜色,主体颜色
			isRefund: false, //是否退款
			radio: 1,
			loading: false,
			refreshing: false,
			finished: false,
			drawer: false,
			dialogTableVisible: false,
			checkList: "商品质量问题",
			chooseDia: false,
			dayFil: "",
			orderList: [],
			zuofeirecordDetail: [],
			page: 2,
			num: 30,
			isHasMore: true,
			isLoading: false,
			loading2: false,
			isErr: false,
			timer: null,
			record: [],
			orderDetail: {},
			shouyinDrawer: false,
			clickIndex: 0,
			ifCaozuo: 0,
			settlement: {
				cash_num: 0,
				wepay_num: 0,
				alipay_num: 0,
				union_num: 0,
				other_num: 0,
				shishou: 0,
				yingshou: 0,
				heji: 0,
				qiankuan: 0,
				value: 0,
				input_num: "",
				placeholder: "优惠",
				name: "优惠",
			},
			notes: "",
			shouyinloading: false,
			printDetails: [],
			kayboardPayTypeChooseIndex: 1,
			kayboardArrsettlement: [
				"7",
				"8",
				"9",
				"赊账",
				"4",
				"5",
				"6",
				"收银",
				"1",
				"2",
				"3",
				"0",
				".",
				"删除",
			],
			detailInfo: {
				status: 1
			},
			headTitle: [
				// '买家管理',
				'订单管理',
				// '自定义1',
				// '自定义2',
				// '自定义3',
			],
			chooseHeaderIndex: 0,
			value1: "",
			curOrder: {},
			curDetai: {},
			obj: {
				searchVal: "",
				time: [],
				status: ""
			},
			duration: [],
			refund: { textarea: "" },
			select: [],
			radio1: 3,
			count: 0,
			pages: {
				total: 0,
				currPage: 0,
				limit: 10,
			},
			form: {},
			header: { mark: "表头", boxList: [] },
			goods: { mark: "商品基础信息", boxList: [] },
			settle: { mark: "结算信息", boxList: [] },
			pay: { mark: "支付信息", boxList: [] },
			other: { mark: "其他信息", boxList: [] }
		};
	},
	computed: {
		time() {
			return t => {
				return dayjs(t * 1000).format("YYYY-MM-DD HH:mm:ss");
			};
		},

		//已退款项

	},
	created() {
		//获取所有订单
		this.getHeight();
		this.getOrder();
		this.getColorConfig();
		this.getPrinterName();
	},
	watch: {
		money: function () {
			this.finalmoney = this.money.toFixed(2);
		},
		checkedColor: function (val) {
			let style = document.createElement("style");
			style.innerHTML = `.el-radio-button__orig-radio:checked + .el-radio-button__inner {
        background-color: ${val} !important;
        border-color: ${val} !important;
      }`;
			document.head.appendChild(style);
		},

		dayFil: {
			handler() {
				const m1 = dayjs()
					.startOf("month")
					.format("YYYY-MM-DD HH:mm:ss"); //月初
				const m2 = dayjs()
					.endOf("month")
					.format("YYYY-MM-DD HH:mm:ss"); //月末
				const d1 = dayjs()
					.startOf("day")
					.format("YYYY-MM-DD HH:mm:ss"); //今日初
				const d2 = dayjs()
					.endOf("day")
					.format("YYYY-MM-DD HH:mm:ss"); //今日末
				const w1 = dayjs()
					.startOf("week")
					.format("YYYY-MM-DD HH:mm:ss"); //本周初
				const w2 = dayjs()
					.endOf("week")
					.format("YYYY-MM-DD HH:mm:ss"); //本月末
				const l1 = dayjs()
					.subtract(1, "day")
					.startOf("day")
					.format("YYYY-MM-DD HH:mm:ss"); //昨日初
				const l2 = dayjs()
					.subtract(1, "day")
					.endOf("day")
					.format("YYYY-MM-DD HH:mm:ss"); //昨日末
				// console.log(121);
				switch (this.dayFil) {
					case "1":
						this.duration = [d1, d2];
						break;
					case "2":
						this.duration = [l1, l2];
						break;
					case "3":
						this.duration = [w1, w2];
						break;
					case "4":
						this.duration = [m1, m2];
						break;
					default:
						break;
				}
			},
			immediate: true
		},
		finalmoney() {
			this.limitInput();
		}
	},
	methods: {

		changeSettlementInput() {

		},

		// 修改当前结算变量类型
		changeSettlementFocusType(type) {
			this.kayboardPayTypeChooseIndex = 0;
		},

		toggleStatus(value) {
			if (value) {
				this.settlement.value = 0;
				this.settlement.placeholder = "优惠";
				this.settlement.discount_num = this.settlement.input_num ? this.settlement.input_num * (-1) : 0
			} else {
				this.settlement.value = 1;
				this.settlement.placeholder = "多收";
				this.settlement.discount_num = this.settlement.input_num ? this.settlement.input_num : 0
			}

			this.countHeji()
			this.countNum()
			this.countShishou()
		},
		onInfinite() {
			this.isLoading = true;
			this.timer = setTimeout(() => {
				if (this.page <= 5) {
					this.data = new Array(this.num * this.page);
					this.page = this.page + 1;
				} else {
					this.isHasMore = false;
				}
				this.isLoading = false;
			}, 100);
		},
		// destroyed() {
		//     clearTimeout(this.timer);
		// },
		onRefresh() {
			this.refreshing = false
			this.pages.currPage = 0
			// this.finished = true
			this.onLoad()
			this.loading = false

		},
		onLoad() {
			this.getOrder()
		},

		getOrderSearch() {
			this.pages.currPage = 0
			this.getOrder()
		},

		getOrder() {
			// this.loading=true

			let params = {
				keywords: this.obj.searchVal,
				page: this.pages.currPage + 1,
			};
			getOrderData(params).then(res => {
				if (res.code == 200) {
					if (this.pages.currPage == 0) {
						this.orderList = res.data.data
					} else {
						this.orderList = [...this.orderList, ...res.data.data];
					}
					this.pages.currPage = res.data.current_page
					this.total = res.data.total;



					if (this.orderList.length >= this.total) {
						this.finished = true;
						return
					}
					this.loading2 = false;

				} else {
					this.$message.error(res.msg);
				}
			});

		},

		lookOrder(item) {
			this.orderDetail = item
			this.drawer = true;
			this.getOrderDetail(item.piao_num, this.orderDetail.id)

		},
		getOrderDetail(piao_num, order_id) {

			// this.loading=true

			let params = {
				piao_num: piao_num,
				order_id: order_id
			};
			getOrderDetailData(params).then(res => {
				if (res.code == 200) {
					// this.loading=false
					this.record = res.data
				} else {
					this.$message.error(res.msg);
				}
			});

		},
		getZuofeiOrderDetail(fid) {
			// this.loading=true
			this.dialogTableVisible = true
			let params = {
				order_id: fid
			};
			getZuofeiOrderDetailData(params).then(res => {
				if (res.code == 200) {
					// this.loading=false
					this.zuofeirecordDetail = res.data
				} else {
					this.$message.error(res.msg);
				}
			});

		},



		getHeight() {
			this.systemHeight = window.innerHeight;
			this.systemWidth = window.innerWidth;
		},


		zuofeiOrder(order_id) {
			this.$confirm("确认作废该订单?", "确认信息", {
				distinguishCancelAndClose: true,
				confirmButtonText: "确定",
				cancelButtonText: "取消"
			})
				.then(() => {
					let params = {
						id: order_id,
						zuofei: 1
					};
					zuofeiOrderData(params).then(res => {
						if (res.code == 200) {
							this.$message.success("作废成功");
							this.drawer = false
							this.pages.currPage = 0;
							this.getOrder();
						} else {
							this.$message.error(res.msg);
						}
					});

				});

		},

		updateOrder(order_id) {


			// this.$router.push({
			//         path:'/nav/cashier',
			//         query:{car_id:2304}
			// })
			// return false

			this.$confirm("确认修改该订单?", "确认信息", {
				distinguishCancelAndClose: true,
				confirmButtonText: "确定",
				cancelButtonText: "取消"
			})
				.then(() => {
					let params = {
						id: order_id
					};
					updateOrderData(params).then(res => {
						if (res.code == 200) {
							this.$message.success("改单成功");
							this.drawer = false
							this.$router.push({
								path: '/nav/cashier',
								query: { car_id: res.data.car_id, maijia_id: res.data.maijia_id, maijia_name: res.data.maijia }
							})
							// this.getOrder();
						} else {
							this.$message.error(res.msg);
						}
					});


				});

		},
		shareOrderStatus(orderItem) {
			this.diashare = true;
			this.shareOrderItem = orderItem;
		},

		// 对话框关闭
		handleDialogClose() {
			this.diashare = false;
		},

		// 图片分享
		handleImageShared(orderId) {
			console.log('图片分享', orderId);

		},

		// 订单分享
		handleOrderShared(orderId) {
			console.log('订单分享', orderId);
		},
		isFieldChecked(key, fieldName) {
			const groupList = this.checkboxConfig[key].boxList;
			console.log(groupList);
			if (!groupList) {
				return false;
			}
			return groupList.some(
				item => item.field_name === fieldName && item.checked
			);
		},
		transTime(timestamp) {
			// timestamp 为时间戳
			const date = new Date(Number(timestamp));
			const year = date.getFullYear();
			const month = date.getMonth() + 1;
			const day = date.getDate();
			const hour = date.getHours();
			const minute = date.getMinutes();
			const second = date.getSeconds();

			return `${year}-${month
				.toString()
				.padStart(2, "0")}-${day
					.toString()
					.padStart(2, "0")} ${hour
						.toString()
						.padStart(2, "0")}:${minute
							.toString()
							.padStart(2, "0")}:${second.toString().padStart(2, "0")}`;

			// time 即为转换后的日期时间字符串
		},

		async handleHtmlPrinting(templateType) {

			let printer_info = JSON.parse(localStorage.getItem("printer_info"))


			try {
				await makebase64QRCode(printer_info.shoukuan_link, this.printDetails);

				if (templateType === 3) {
					this.previewContent = generatePrintContent3(
						this.printDetails,
						this.transTime,

					);
				} else if (templateType === 4) {
					if(this.printDetails.order_detail.length>1){
						this.previewContent = generatePrintContent3(
							this.printDetails,
							this.transTime,
						
						);
					}else{
						this.previewContent = generatePrintContent4(
							this.printDetails,
						);
					}
					
				}


				// this.loading = this.$loading({
				// 	lock: true,
				// 	spinner: "el-icon-loading",
				// 	customClass: "all-body-loading",
				// 	text: "打印中..."
				// });

				await executePrint(
					templateType,
					this.loading,
					this.previewContent
				);
				await new Promise(resolve => setTimeout(resolve, 1000));
				window.Android.pCutPaper(66, 50);
			} catch (error) {
				console.error("打印失败：", error);
				this.$message.error("错误：" + error.message);
			} finally {
				if (this.loading) {
					this.loading.close();
					this.loading = null;
				}
			}
		},

		async printDetail(item) {//先请求打印的数据

			let params = { order_id: item.order_id, order_detail_id: item.id }
			orderGetPrintOrder(params).then(res => {
				if (res.code == 200) {
					this.printOrder(res.data);
				} else {
					this.$message.error(res.msg);
				}
			});

		},
		async printOrder(item) {

			// console.log(item)
			// return
			let print_type = localStorage.getItem("printer_type");

			let printer_info = JSON.parse(localStorage.getItem("printer_info"))


			if (printer_info.printer_type == "0") {//思普瑞特打印机

				this.printDetails = item

				switch (printer_info.use_print_template) {
					case 1:
						setTimeout(sprt_printer(item), 1000);
						break;
					case 2:
						setTimeout(sprt_printer2(item), 1000);
						break;
					case 3:
					case 4:
						await this.handleHtmlPrinting(printer_info.use_print_template);
						break;
					default:
						break;
				}

			}
			if (printer_info.printer_type == 1) {//飞蛾打印机
				let params = { order_id: item.id }
				orderListPrint(params).then(res => {
					if (res.code == 200) {
						this.$message.success("打印成功");
					} else {
						this.$message.error(res.msg);
					}
				});
			}


		},
		//操作还款
		huankuanOrder(item) {

			this.shouyinDrawer = true
			this.shouyinloading = false
			this.settlement.yingshou = item.yingshou
			this.settlement.heji = item.yingshou
			this.settlement.shishou = item.yingshou
			this.settlement.cash_num = item.yingshou
			this.settlement.wepay_num = 0
			this.settlement.alipay_num = 0
			this.settlement.union_num = 0
			this.settlement.other_num = 0

			this.settlement.input_num = ""
			this.settlement.placeholder = "优惠"
			this.settlement.name = "优惠"
			this.settlement.value = 0
			this.settlement.discount_num = 0
			this.kayboardPayTypeChooseIndex = 1
			this.ifCaozuo = 0



		},

		chooseIndexPayType(item) {
			let num = 0;
			this.kayboardPayTypeChooseIndex = item;
			if (this.kayboardPayTypeChooseIndex == "1") {
				if (this.ifCaozuo == 0) {
					num = this.settlement.heji
					this.settlement.wepay_num = 0
					this.settlement.alipay_num = 0
					this.settlement.union_num = 0
					this.settlement.other_num = 0
				} else {
					num = this.settlement.heji - this.settlement.wepay_num - this.settlement.alipay_num - this.settlement.union_num - this.settlement.other_num;

				}
				if (num < 0) {
					num = 0;
				}
				this.settlement.cash_num = num
			}
			if (this.kayboardPayTypeChooseIndex == "2") {
				if (this.ifCaozuo == 0) {
					num = this.settlement.heji
					this.settlement.cash_num = 0
					this.settlement.alipay_num = 0
					this.settlement.union_num = 0
					this.settlement.other_num = 0
				} else {
					num = this.settlement.heji - this.settlement.cash_num - this.settlement.alipay_num - this.settlement.union_num - this.settlement.other_num;
				}
				if (num < 0) {
					num = 0;
				}
				this.settlement.wepay_num = num
			}
			if (this.kayboardPayTypeChooseIndex == "3") {
				if (this.ifCaozuo == 0) {
					num = this.settlement.heji
					this.settlement.cash_num = 0
					this.settlement.wepay_num = 0
					this.settlement.union_num = 0
					this.settlement.other_num = 0
				} else {
					num = this.settlement.heji - this.settlement.cash_num - this.settlement.wepay_num - this.settlement.union_num - this.settlement.other_num;
				}
				if (num < 0) {
					num = 0;
				}
				this.settlement.alipay_num = num
			}
			if (this.kayboardPayTypeChooseIndex == "4") {
				if (this.ifCaozuo == 0) {
					num = this.settlement.heji
					this.settlement.cash_num = 0
					this.settlement.wepay_num = 0
					this.settlement.alipay_num = 0
					this.settlement.other_num = 0
				} else {
					num = this.settlement.heji - this.settlement.cash_num - this.settlement.wepay_num - this.settlement.alipay_num - this.settlement.other_num;
				}
				if (num < 0) {
					num = 0;
				}
				this.settlement.union_num = num
			}
			if (this.kayboardPayTypeChooseIndex == "5") {
				if (this.ifCaozuo == 0) {
					num = this.settlement.heji
					this.settlement.cash_num = 0
					this.settlement.wepay_num = 0
					this.settlement.alipay_num = 0
					this.settlement.union_num = 0
				} else {
					num = this.settlement.heji - this.settlement.cash_num - this.settlement.wepay_num - this.settlement.alipay_num - this.settlement.union_num;
				}
				if (num < 0) {
					num = 0;
				}
				this.settlement.other_num = num
			}
			this.countShishou();
		},


		keyboardClick(item) {
			if (this.kayboardPayTypeChooseIndex !== 0) {
				this.ifCaozuo = 1;
			}
			if (item == '清空') {
				this.actualPayment = '';
			} else if (item == '删除') {

				if (this.kayboardPayTypeChooseIndex == 0) { //现金
					this.settlement.input_num = this.settlement.input_num.substring(0, this.settlement.input_num
						.length - 1);
					if (!this.settlement.input_num) {
						this.settlement.input_num = 0;
					}
					if (this.settlement.value) {
						this.settlement.discount_num = this.settlement.input_num
					} else {
						this.settlement.discount_num = this.settlement.input_num * (-1)
					}

					this.countHeji();
					this.countNum();
					this.countShishou()
				}
				if (this.kayboardPayTypeChooseIndex == "1") { //现金
					this.settlement.cash_num = this.settlement.cash_num.substring(0, this.settlement.cash_num
						.length - 1);
					if (!this.settlement.cash_num) {
						this.settlement.cash_num = 0;
					}

				}
				if (this.kayboardPayTypeChooseIndex == "2") { //微信
					this.settlement.wepay_num = this.settlement.wepay_num.substring(0, this.settlement.wepay_num
						.length - 1);

					if (!this.settlement.wepay_num) {
						this.settlement.wepay_num = 0;
					}
				}
				if (this.kayboardPayTypeChooseIndex == "3") { //支付宝
					this.settlement.alipay_num = this.settlement.alipay_num.substring(0, this.settlement.alipay_num
						.length - 1);

					if (!this.settlement.alipay_num) {
						this.settlement.alipay_num = 0;
					}
				}
				if (this.kayboardPayTypeChooseIndex == "4") { //银联
					this.settlement.union_num = this.settlement.union_num.substring(0, this.settlement.union_num
						.length - 1);

					if (!this.settlement.union_num) {
						this.settlement.union_num = 0;
					}
				}
				if (this.kayboardPayTypeChooseIndex == "5") { //其他
					this.settlement.other_num = this.settlement.other_num.substring(0, this.settlement.other_num
						.length - 1);
					if (!this.settlement.other_num) {
						this.settlement.other_num = 0;
					}

				}
			} else if (item == '收银') {
				this.addOrder();
			} else {
				if (this.kayboardPayTypeChooseIndex == "1") { //现金
					const settlement_cash_num = tools.assertString(this.settlement.cash_num);
					console.log(this.settlement.cash_num)
					console.log(settlement_cash_num)
					console.log(typeof this.settlement.cash_num)
					if (settlement_cash_num.includes('.')) {
						if (item == '.') return false;
						if (settlement_cash_num.split('.')[1].length < 2) {
							this.settlement.cash_num = `${settlement_cash_num}${item}`;
						}
					} else {
						if (item == '0' && tools.transNumFn(this.settlement.cash_num) == 0) {
							this.settlement.cash_num = `0`;
						} else if (item == '.' && settlement_cash_num.length == 0) {
							this.settlement.cash_num = `0.`;
						} else if (settlement_cash_num === '0' && item != '.') {
							this.settlement.cash_num = `${item}`;
						} else {
							if (settlement_cash_num.length > 8) {
								this.settlement.cash_num = `${settlement_cash_num}`;
							} else {
								this.settlement.cash_num = `${settlement_cash_num}${item}`;
							}

						}
					}


				}
				if (this.kayboardPayTypeChooseIndex == "2") { //微信
					const settlement_wepay_num = tools.assertString(this.settlement.wepay_num);
					if (settlement_wepay_num.includes('.')) {
						if (item == '.') return false;
						if (settlement_wepay_num.split('.')[1].length < 2) {
							this.settlement.wepay_num = `${settlement_wepay_num}${item}`;
						}
					} else {
						if (item == '0' && tools.transNumFn(this.settlement.wepay_num) == 0) {
							this.settlement.wepay_num = `0`;
						} else if (item == '.' && settlement_wepay_num.length == 0) {
							this.settlement.wepay_num = `0.`;
						} else if (settlement_wepay_num === '0' && item != '.') {
							this.settlement.wepay_num = `${item}`;
						} else {
							if (settlement_wepay_num.length > 8) {
								this.settlement.wepay_num = `${settlement_wepay_num}`;
							} else {
								this.settlement.wepay_num = `${settlement_wepay_num}${item}`;
							}

						}
					}


				}
				if (this.kayboardPayTypeChooseIndex == "3") { //支付宝
					const settlement_alipay_num = tools.assertString(this.settlement.alipay_num);
					if (settlement_alipay_num.includes('.')) {
						if (item == '.') return false;
						if (settlement_alipay_num.split('.')[1].length < 2) {
							this.settlement.alipay_num = `${settlement_alipay_num}${item}`;
						}
					} else {
						if (item == '0' && tools.transNumFn(this.settlement.alipay_num) == 0) {
							this.settlement.alipay_num = `0`;
						} else if (item == '.' && settlement_alipay_num.length == 0) {
							this.settlement.alipay_num = `0.`;
						} else if (settlement_alipay_num === '0' && item != '.') {
							this.settlement.alipay_num = `${item}`;
						} else {
							if (settlement_alipay_num.length > 8) {
								this.settlement.alipay_num = `${settlement_alipay_num}`;
							} else {
								this.settlement.alipay_num = `${settlement_alipay_num}${item}`;
							}

						}
					}
				}
				if (this.kayboardPayTypeChooseIndex == "4") { //银联
					const settlement_union_num = tools.assertString(this.settlement.union_num);
					if (settlement_union_num.includes('.')) {
						if (item == '.') return false;
						if (settlement_union_num.split('.')[1].length < 2) {
							this.settlement.union_num = `${settlement_union_num}${item}`;
						}
					} else {
						if (item == '0' && tools.transNumFn(this.settlement.union_num) == 0) {
							this.settlement.union_num = `0`;
						} else if (item == '.' && settlement_union_num.length == 0) {
							this.settlement.union_num = `0.`;
						} else if (settlement_union_num === '0' && item != '.') {
							this.settlement.union_num = `${item}`;
						} else {
							if (settlement_union_num.length > 8) {
								this.settlement.union_num = `${settlement_union_num}`;
							} else {
								this.settlement.union_num = `${settlement_union_num}${item}`;
							}

						}
					}
				}
				if (this.kayboardPayTypeChooseIndex == "5") { //其他
					const settlement_other_num = tools.assertString(this.settlement.other_num);
					if (settlement_other_num.includes('.')) {
						if (item == '.') return false;
						if (settlement_other_num.split('.')[1].length < 2) {
							this.settlement.other_num = `${settlement_other_num}${item}`;
						}
					} else {
						if (item == '0' && tools.transNumFn(this.settlement.other_num) == 0) {
							this.settlement.other_num = `0`;
						} else if (item == '.' && settlement_other_num.length == 0) {
							this.settlement.other_num = `0.`;
						} else if (settlement_other_num === '0' && item != '.') {
							this.settlement.other_num = `${item}`;
						} else {
							if (settlement_other_num.length > 8) {
								this.settlement.other_num = `${settlement_other_num}`;
							} else {
								this.settlement.other_num = `${settlement_other_num}${item}`;
							}

						}
					}
				}
				if (this.kayboardPayTypeChooseIndex == 0) { //现金
					const settlement_input_num = tools.assertString(this.settlement.input_num);
					if (settlement_input_num.includes('.')) {
						if (item == '.') return false;
						if (settlement_input_num.split('.')[1].length < 2) {
							this.settlement.input_num = `${settlement_input_num}${item}`;
						}
					} else {
						if (item == '0' && tools.transNumFn(this.settlement.input_num) == 0) {
							this.settlement.input_num = `0`;
						} else if (item == '.' && settlement_input_num == 0) {
							this.settlement.input_num = `0.`;
						} else if (settlement_input_num === '0' && item != '.') {
							this.settlement.input_num = `${item}`;
						} else {
							if (settlement_input_num.length > 8) {
								this.settlement.input_num = `${settlement_input_num}`;
							} else {
								this.settlement.input_num = `${settlement_input_num}${item}`;
							}

						}
					}
					if (this.settlement.value) {
						this.settlement.discount_num = this.settlement.input_num
					} else {
						this.settlement.discount_num = this.settlement.input_num * (-1)
					}
					this.countHeji();
					this.countNum();
				}
				this.countShishou()
			}
		},

		countShishou() {
			this.settlement.shishou = parseFloat(this.settlement.cash_num) +
				parseFloat(this.settlement.wepay_num) +
				parseFloat(this.settlement.alipay_num) +
				parseFloat(this.settlement.union_num) +
				parseFloat(this.settlement.other_num);

		},
		countHeji() {
			this.settlement.heji = parseFloat(this.settlement.yingshou) + parseFloat(this.settlement.discount_num);
			console.log(this.settlement.heji)
		},
		// 输入的金额重置
		countNum() {
			this.settlement.cash_num = this.settlement.heji
			this.settlement.wepay_num = 0;
			this.settlement.alipay_num = 0;
			this.settlement.union_num = 0;
			this.settlement.other_num = 0;
		},

		addOrder(status) {
			if (this.settlement.shishou > this.settlement.heji) {
				this.$message.error("实收金额不能大于还款金额");
				return false
			}

			if (this.settlement.input_num > this.settlement.yingshou && this.settlement.value == 0) {
				this.$message.error("优惠金额不能大于订单金额");
				return false;
			}

			let params = {
				order_id: this.orderDetail.id,
				maijia_id: this.orderDetail.maijia_id,
				piao_num: this.orderDetail.piao_num,
				order_num: this.orderDetail.order_num,
				notes: this.notes,
				cash_num: this.settlement.cash_num,
				heji: this.settlement.heji,
				shishou: this.settlement.shishou,
				wepay_num: this.settlement.wepay_num,
				alipay_num: this.settlement.alipay_num,
				union_num: this.settlement.union_num,
				other_num: this.settlement.other_num,

				input_num: this.settlement.input_num,
				discount_num: this.settlement.discount_num,
				value: this.settlement.value,
				yingshou: this.settlement.yingshou,
			};

			// this.shouyinloading=true

			huankuanData(params).then(res => {
				if (res.code == 200) {
					this.shouyinloading = false
					this.drawer = false
					this.$message.success("还款成功");
					this.shouyinDrawer = false
					this.pages.currPage = 0
					this.getOrder()
					//打印
					this.printOrder(res.data)


				} else {
					this.$message.error(res.msg);
				}
			});
		},


		limitInput() {
			this.finalmoney =
				("" + this.finalmoney) // 第一步：转成字符串
					.replace(/[^\d^\.]+/g, "") // 第二步：把不是数字，不是小数点的过滤掉
					.replace(/^0+(\d)/, "$1") // 第三步：第一位0开头，0后面为数字，则过滤掉，取后面的数字
					.replace(/^\./, "0.") // 第四步：如果输入的第一位为小数点，则替换成 0. 实现自动补全
					.match(/^\d*(\.?\d{0,2})/g)[0] || ""; // 第五步：最终匹配得到结果 以数字开头，只有一个小数点，而且小数点后面只能有0到2位小数
		},
		// 获取当前年月日时分秒
		getNowTime() {
			function formatNumber(num) {
				return num < 10 ? `0${num}` : `${num}`;
			}

			const now = new Date();
			const year = now.getFullYear();
			const month = formatNumber(now.getMonth() + 1);
			const day = formatNumber(now.getDate());
			const hour = formatNumber(now.getHours());
			const minute = formatNumber(now.getMinutes());
			const second = formatNumber(now.getSeconds());
			return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
		},


		// 获取打印机名称
		async getPrinterName() {
			const res = await getReceiptField();
			if (res.code === 200) {
				// 表头
				this.header.boxList = res.data.field.header;
				// 商品基础信息
				this.goods.boxList = res.data.field.goods;
				// 结算信息
				this.settle.boxList = res.data.field.settle;
				// 支付信息
				this.pay.boxList = res.data.field.pay;
				// 其他信息
				this.other.boxList = res.data.field.other;
				// 打印机
				this.form.printer = res.data.printer_name;
				// 默认打印份数
				this.form.count = res.data.printer_number;
				// 小票规格
				this.form.printer_spec = res.data.printer_spec;
				// 打印机
				this.form.printer = res.data.printer_name;
				// 默认打印份数
				this.form.count = res.data.printer_number;
				// 小票规格
				this.form.printer_spec = res.data.printer_spec;
				// 是否自动打印
				res.data.field.printer.forEach(item => {
					if (item.field_name == "is_auto_receipt") {
						// console.log(item, "is_auto_receipt");
						if (item.value == 1) {
							this.form.isAoto = 1;
						} else {
							this.form.isAoto = 0;
						}
					}
				});
			}
		},
		// 获取颜色设置
		async getColorConfig() {
			const res = await getColorConfig();
			if (res.code === 200) {
				res.data.forEach(item => {
					switch (item.name) {
						case "desk_color":
							// 收银台主体颜色
							this.checkedColor = item.value;
							break;
						default:
							break;
					}
				});
			} else {
				this.$message.error(res.msg);
			}
		},
		load() {
			this.count += 2;
		},
		// 获取所有订单

		//切换订单
		changeOrder(index) {
			console.log('changeOrder index==>', index);

			this.clickIndex = index;
			this.curOrder = this.orderList[index];
			getOrderDetail(this.orderList[index].id).then(res => {
				if (res.code === 200) {
					this.curDetai = res.data;
				}
			});
		},
		//点击筛选
		async search() {
			console.log("value1", this.value1, this.tabPosition, this.obj.status);
			console.log(this.duration);
			await this.getAllOrder({
				totalPage: 0,
				curpage: 1,
				size: 10
			});
			this.chooseDia = false;
			this.obj = {
				searchVal: "",
				time: [],
				status: ""
			};
			this.dayFil = "";
			this.duration = [];
		},
		//关闭筛选框
		closeFilter() {
			this.chooseDia = false;
			this.obj = {
				searchVal: "",
				time: [],
				status: ""
			};
			this.dayFil = "";
			this.duration = [];
		},
		// 选中退款项
		selectOne(selection, row) {
			// console.log(1,selection);
			this.select = [...selection];
		},
		//确认退款

		// 打印
		printInfo() {
			// this.showPrint = true;
			this.$nextTick(() => {
				// 组装打印参数
				// let positionVal = [];
				// positionVal.push({ value: "订单小票", font: 5, type: "header" });
				// positionVal.push({
				//   text: "下单时间:",
				//   value: this.time(this.curDetai.order.pay_time),
				//   type: "normal",
				// });
				// positionVal.push({
				//   text: "订单号:",
				//   value: this.curDetai.order.ord_bh,
				//   type: "normal",
				// });
				// positionVal.push({
				//   text: "收银员：",
				//   value: this.curOrder.cashier_name,
				//   type: "normal",
				// });
				// positionVal.push({ value: "商品信息", font: 5, type: "header" });
				// positionVal.push({
				//   text: "商品名称/单价/重量/数量/小计",
				//   type: "split",
				// });
				// this.curOrder.api_items.forEach((item) => {
				//   let tableName =
				//     item.goods_name +
				//     "/¥" +
				//     item.single_price +
				//     item.spec_name +
				//     "/" +
				//     item.buy_num +
				//     item.spec_name +
				//     "/" +
				//     item.sum_money +
				//     "/";
				//   positionVal.push({
				//     text: tableName,
				//     type: "split",
				//   });
				// });
				// positionVal.push({ value: "结算信息", font: 5, type: "header" });
				// if (this.curDetai.order) {
				//   positionVal.push({
				//     text: "订单实付",
				//     value: "¥" + this.curDetai.order.pay_price,
				//     type: "normal",
				//   });
				//   positionVal.push({
				//     text: "付款方式",
				//     value:
				//       this.curDetai.order.pay_type === "balance"
				//         ? "余额"
				//         : this.curDetai.order.pay_type === "wechat"
				//         ? "微信"
				//         : this.curDetai.order.pay_type === "alipay"
				//         ? "支付宝"
				//         : this.curDetai.order.pay_type === "cash"
				//         ? "现金"
				//         : "",
				//     type: "normal",
				//   });
				//   positionVal.push({
				//     text: "优惠合计",
				//     value: "¥" + this.curDetai.order.order_discount_money,
				//     type: "normal",
				//   });
				//   positionVal.push({
				//     text: "优惠券",
				//     value: "¥" + this.curDetai.order.coupon_money,
				//     type: "normal",
				//   });
				//   positionVal.push({
				//     text: "折扣",
				//     value: this.curDetai.order.order_discount
				//       ? this.curDetai.order.order_discount
				//       : "-",
				//     type: "normal",
				//   });
				//   positionVal.push({
				//     text: "抹零",
				//     value: "¥" + this.curDetai.order.zero_money,
				//     type: "normal",
				//   });
				// }
				// positionVal.push({ value: "会员信息", font: 5, type: "header" });
				// positionVal.push({
				//   text: "会员手机",
				//   value: this.curDetai.member.mobile || "",
				//   type: "normal",
				// });
				// positionVal.push({
				//   text: "会员余额",
				//   value: "¥" + (this.curDetai.member.money || ""),
				//   type: "normal",
				// });
				// positionVal.push({
				//   text: "剩余积分",
				//   value: this.curDetai.member ? this.curDetai.member.score : "0",
				//   type: "normal",
				// });
				// if (this.refundItem.length > 0) {
				//   positionVal.push({ value: "退款信息", font: 5, type: "header" });
				//   this.refundItem.forEach((item) => {
				//     positionVal.push({
				//       text: "退款商品",
				//       value: item.goods_name,
				//       type: "normal",
				//     });
				//     positionVal.push({
				//       text: "退款金额",
				//       value: "¥" + item.refund_money,
				//       type: "normal",
				//     });
				//     positionVal.push({
				//       text: "退款方式",
				//       value:
				//         item.refund_way === 1
				//           ? "原路退回"
				//           : item.refund_way === 2
				//           ? "现金"
				//           : "",
				//       type: "normal",
				//     });
				//     positionVal.push({
				//       text: "退款原因",
				//       value: item.reason,
				//       type: "normal",
				//     });
				//     positionVal.push({
				//       text: "退款时间",
				//       value: this.time(item.refund_time),
				//       type: "normal",
				//     });
				//   });
				// }
				// this.printInfo();
				// 打印
				this.other.boxList.forEach(item => {
					if (item.field_name == "bill_qr_code_check") {
						item.value = "暂无发票地址";
					}
				});
				let positionVal = [];
				this.header.boxList.forEach(item => {
					if (item.field_name === "header" && item.checked) {
						positionVal.push({
							value: "万象优鲜",
							font: 5,
							type: "header"
						});
					}
					if (item.field_name != "header" && item.checked) {
						positionVal.push({
							text: item.flield_name,
							value: this.contentSelect(item.field_name).toString(),
							type: "normal"
						});
					}
				});
				let tablename = "";
				this.goods.boxList.forEach(item => {
					if (item.field_name === "goods_name" && item.checked === true) {
						tablename += "商品名称/";
					}
					if (item.field_name === "goods_danjia" && item.checked === true) {
						tablename += "单价/";
					}
					if (item.field_name === "goods_shuliang" && item.checked === true) {
						tablename += "数量/";
					}
					if (item.field_name === "goods_jiage" && item.checked === true) {
						tablename += "价格/";
					}
				});
				positionVal.push({
					text: tablename,
					type: "split"
				});
				this.curOrder.api_items.forEach((num1, index) => {
					let num = { ...num1 };
					let tablename2 = "";
					this.goods.boxList.forEach(item => {
						if (item.field_name === "goods_name" && item.checked === true) {
							tablename2 = tablename2 + num.goods_name + "/";
						}
						if (item.field_name === "goods_danjia" && item.checked === true) {
							tablename2 = tablename2 + num.single_price + "/";
						}
						if (item.field_name === "goods_shuliang" && item.checked === true) {
							tablename2 = tablename2 + num.buy_num + "/";
						}
						if (item.field_name === "goods_jiage" && item.checked === true) {
							tablename2 = tablename2 + num.sum_money + "/";
						}
					});
					positionVal.push({
						text: tablename2,
						type: "split"
					});
				});
				this.goods.boxList.forEach(item => {
					if (item.field_name === "goods_spec" && item.checked === true) {
						positionVal.push({
							text: "规格",
							value: "暂无",
							type: "normal"
						});
					}
					if (item.field_name === "item_no" && item.checked === true) {
						positionVal.push({
							text: "商品货号：",
							value: item.goods_barcode || "",
							type: "normal"
						});
					}
					if (item.field_name === "goods_zongshu" && item.checked === true) {
						positionVal.push({
							text: "商品总数:",
							value: this.curOrder.api_items.length.toString(),
							type: "normal"
						});
					}
					if (item.field_name === "goods_sales" && item.checked === true) {
						positionVal.push({
							text: "商品优惠:",
							value: "",
							// Number(this.preferential).toFixed(1) +"元"
							type: "normal"
						});
					}
					if (item.field_name === "sales_total" && item.checked === true) {
						positionVal.push({
							text: "优惠合计:",
							value: "",
							// Number(this.preferential).toFixed(1) + "元"
							type: "normal"
						});
					}
				});
				this.settle.boxList.forEach(item => {
					if (item.field_name != "bar_code" && item.checked === true) {
						console.log(
							this.contentSelect(item.field_name),
							item.field_name,
							"this.contentSelect(item.field_name)"
						);
						positionVal.push({
							text: item.flield_name,
							value: this.contentSelect(item.field_name).toString(),
							type: "normal"
						});
					}
				});
				positionVal.push({
					value: this.curDetai.order.ord_bh,
					font: 1,
					type: "tiaoma"
				});
				this.pay.boxList.forEach(item => {
					if (item.checked) {
						positionVal.push({
							text: item.flield_name,
							value: this.contentSelect(item.field_name).toString(),
							type: "normal"
						});
					}
				});
				this.other.boxList.forEach((item, index) => {
					if (item.checked) {
						if (
							item.field_name == "mini_qr_code_check" ||
							item.field_name == "bill_qr_code_check"
						) {
							positionVal.push({
								text: item.flield_name,
								value: item.value,
								font: 0,
								type: "qr"
							});
						} else {
							positionVal.push({
								text: item.flield_name,
								value: this.contentSelect(item.field_name).toString(),
								type: "normal"
							});
						}
					}
				});
				console.log(positionVal, "positionValpositionVal");
				let isOnline = window.getPrintStatus(this.form.printer)
					? window.getPrintStatus(this.form.printer)
					: false;
				if (isOnline && isOnline == "online") {
					// this.loading = Loading.service({
					//   lock: true,
					//   spinner: "el-icon-loading",
					//   customClass: "all-body-loading",
					//   text: "打印中..."
					// });
					let printIfno = {
						//------这里用用于打印  打印的展示信息
						name: "订单小票",
						type: 0,
						SType: "dingdan",
						w: parseInt(this.form.printer_spec.slice(0, -2)).toString(),
						h: (positionVal.length * 20).toString(),
						copies: this.form.count
					};
					let infoP = tiaoma({
						info: printIfno,
						position: positionVal
					});
					let JSONStr = JSON.stringify(infoP);
					console.log("传给C的打印数据：", infoP);
					window.wxPrint(JSONStr);
					setTimeout(() => {
						this.showPrint = false;
						this.loading.close();
						this.loading = null;
					}, 1000);
				} else {
					this.$message.error("打印机未连接");
				}
			});
		}
	}
};
</script>

<style scoped lang="less">
.switch-and-delete-container {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 20%;
}

.custom-switch {
	position: relative;
	display: flex;
	border: 1px solid gray;
	border-radius: 4px;
	overflow: hidden;
	cursor: pointer;
	transition: border-color 0.3s;
	width: 100px;
	height: 32px;
}

.custom-switch.active {
	border-color: #808080;
}

.custom-switch.inactive {
	border-color: #808080;
}

.switch-option {
	position: relative;
	flex: 1;
	text-align: center;
	line-height: 28px;
	font-size: 16px;
	z-index: 2;
	user-select: none;
}

.stop-sale {
	color: #808080;
}

.on-sale {
	color: #808080;
}

.custom-switch.active .stop-sale {
	color: #fff;
	background-color: #fff;

}

.custom-switch.active .on-sale {
	color: #fff;
}

.custom-switch.inactive .stop-sale {
	color: #808080;
}

.custom-switch.inactive .on-sale {
	color: #fff;
	background-color: #fff;
}

.custom-switch.inactive .stop-sale {
	color: #fff;
}

.custom-switch::before {
	content: '';
	position: absolute;
	top: 0px;
	bottom: 0px;
	left: 0px;
	width: 50%;
	background-color: #808080;
	border-radius: 1px;
	transition: transform 0.3s, background-color 0.3s;
	z-index: 1;
	padding: 0px;
}

.custom-switch.active::before {
	transform: translateX(100%);
	background-color: #808080;
}

.custom-switch .switch-option {
	white-space: nowrap;
}

.settlement {
	user-select: none;

	.chooseBtn {

		border: #4ca75b 3px solid;
	}

	.keyboardsettlement {


		ul {
			display: grid;
			grid-template-columns: repeat(4, 1fr);
			// column-gap: 10px;
			grid-template-rows: repeat(4, 1fr);

			// row-gap: 10px;
			li {
				list-style: none;
				display: flex;
				align-items: center;
				justify-content: center;
				// border: 2px solid #e8eaeb;
				// box-shadow: 0px 4px 0px #e8eaeb;
			}

			li:active {
				background-color: #71ba91;
			}

			.keyboardConfirm {
				user-select: none;
				grid-column-start: 4;
				grid-column-end: 5;
				grid-row-start: 1;
				grid-row-end: 5;
				background: #4ca75b;
				;
				color: #fff;
				border: none;
				// box-shadow: 0px 4px 0px #4ca75b;
			}

			.keyboardNum {
				user-select: none;
				background: #343a54;
				color: #ffffff;
			}



			.keyboardOncredit {
				user-select: none;
				grid-column-start: 4;
				grid-column-end: 5;
				grid-row-start: 1;
				grid-row-end: 3;
				background: #ec683e;
				color: #fff;
				border: none;
				// box-shadow: 0px 4px 0px #ec683e;
			}

			.keyboardDel {
				user-select: none;
				background: #343a54;
				color: #ffffff;
			}
		}
	}



}


.sub {
	width: 100%;
	background: #f4f6f7;
	display: flex;
	font-size: 14px;

	.list {

		.img-box-header {
			.chooseHeader {
				float: left;
				border-bottom: 2px solid #51b360;
				color: #51b360;
				font-weight: bold;
			}

			.header {
				float: left;
				color: #808181;
			}
		}


		// overflow-y: scroll;

		.findList {
			width: 100%;
			height: 60px;
			padding: 10px 20px 10px 10px;
			box-sizing: border-box;
			display: flex;
			justify-content: space-between;

			.intKuang {
				// width: 330px;
				// height: 42px;
				// border-radius: 4px;
				// overflow: hidden;
				// background: #f5f6f7;

				// input {
				//   width: 100%;
				//   height: 40px;
				//   border: none;
				//   background: #f5f6f7;
				//   padding-left: 20px;
				//   outline: none;
				//   font-size: 16px;
				// }
			}

			.choose {
				span {
					vertical-align: middle;
					display: inline-block;
					margin-top: 10px;
					font-size: 16px;
				}

				img {
					vertical-align: middle;
					// margin-left: 20px;
					margin-top: 10px;
				}
			}
		}

		.orderList {
			width: 100%;
			// height: calc(100vh - 90px);
			overflow-y: scroll;

			ul {
				li {
					list-style: none;
					padding: 16px 16px;
					box-sizing: border-box;
					border-bottom: 1px solid #f2f2f2;

					.itemTop {
						margin-bottom: 8px;

						img {
							vertical-align: middle;
						}

						span {
							vertical-align: middle;
							font-size: 16px;
							color: #1f2d23;
							// margin-left: 8px;
						}
					}

					.itemMiddel {
						font-size: 16px;
						margin-bottom: 8px;
					}

					.itemButtom {
						.num {
							font-size: 16px;
						}

						.price {
							font-size: 18px;
							font-weight: 800;
							// margin-right: 137px;
						}

						.time {
							font-size: 14px;
							color: #989ea7;
							float: right;

							img {
								vertical-align: middle;
							}

							span {
								vertical-align: middle;
							}
						}
					}
				}

				.clickColor {
					background: #f7f9fa;
				}
			}
		}

		.page {
			width: 100%;
			height: 20px;
			display: flex;
			justify-content: space-between;
		}
	}

	.goodsDetail {
		flex: 1;
		height: 100vh;
		background: #fff;
		border-left: 1px solid #f2f2f2;
		padding: 20px 0;
		box-sizing: border-box;
		overflow: hidden;

		.detailTop {
			width: 100%;
			background: #f7f9fa;
			padding: 6px 0 6px 7px;
			margin: 0 20px;
			margin-bottom: 20px;
			border-radius: 4px;

			img {
				vertical-align: middle;
			}

			span {
				vertical-align: middle;
				margin-left: 20px;
				font-size: 16px;
				color: #1f2d23;
			}
		}

		.detailInfo {
			width: 100%;
			height: calc(100% - 160px);
			margin: 0 20px;
			background: #fff;
			overflow: hidden;

			.leftInfo {
				width: 100%;
				height: 450px;
				overflow-y: auto;
				// float: left;

				.tit {
					width: 100%;
					height: 41px;
					line-height: 41px;
					background: #f7f9fa;
					border-radius: 4px;
					font-weight: 600;
					color: #060c1b;
					font-size: 18px;
					padding-left: 27px;
					box-sizing: border-box;
					position: relative;
					margin-bottom: 24px;
				}

				.tit::before {
					content: "";
					width: 3px;
					border-radius: 1px;
					background: @desk-color;
					height: 16px;
					position: absolute;
					top: 13px;
					left: 16px;
				}

				ul {
					li {
						list-style: none;
						margin-bottom: 24px;
						overflow: hidden;

						.goodsImg {
							float: left;
							margin-right: 16px;
							border-radius: 4px;
							border: 1px solid #f2f2f2;
							overflow: hidden;

							img {
								width: 80px;
								height: 80px;
							}
						}

						.goodsInfo {
							float: left;

							.name {
								color: #1f2d23;
								font-weight: 600;
								font-size: 18px;
								margin-bottom: 8px;
							}

							.price {
								font-size: 14px;
								margin-bottom: 8px;
								color: #1f2d23;
							}

							.heavy {
								font-size: 14px;
								color: #1f2d23;
							}
						}

						.goodsPrice {
							color: #1f2d23;
							font-weight: 600;
							font-size: 18px;
							float: right;
							margin-top: 55px;
						}
					}
				}
			}

			.shu {
				width: 1px;
				height: 100%;
				background: #f2f2f2;
				// float: left;
				margin: 0 28px;
			}

			.rightInfo {
				width: 100%;
				height: 450px;
				overflow-y: auto;
				// float: left;

				.tit {
					width: 100%;
					height: 41px;
					line-height: 41px;
					background: #f7f9fa;
					border-radius: 4px;
					font-weight: 600;
					color: #060c1b;
					font-size: 18px;
					padding-left: 27px;
					box-sizing: border-box;
					position: relative;
					margin-bottom: 24px;
				}

				.tit::before {
					content: "";
					width: 3px;
					border-radius: 1px;
					background: @desk-color;
					height: 16px;
					position: absolute;
					top: 13px;
					left: 16px;
				}

				.order {
					margin-bottom: 24px;

					p {
						font-size: 14px;
						color: #1f2d23;
						margin-bottom: 6px;

						.oKey {
							margin-right: 106px;
						}
					}

					.oTit {
						.oKey {
							font-size: 16px;
							font-weight: 600;
							margin-right: 98px;
						}

						.oVal {
							font-size: 16px;
							color: @desk-font-color;
						}
					}
				}

				.discounts {
					margin-bottom: 24px;

					p {
						font-size: 14px;
						color: #1f2d23;
						margin-bottom: 6px;
					}

					.oTit {
						.oKey {
							font-size: 16px;
							font-weight: 600;
							margin-right: 98px;
						}

						.oVal {
							font-size: 16px;
							color: @desk-font-color;
						}
					}
				}

				.member {
					margin-bottom: 24px;

					p {
						font-size: 14px;
						color: #1f2d23;
						margin-bottom: 6px;

						.oKey {
							margin-right: 106px;
						}
					}

					.oTit {
						.oKey {
							font-size: 16px;
							font-weight: 600;
						}

						.oVal {
							font-size: 16px;
							color: @desk-font-color;
						}
					}
				}

				.refund {
					p {
						font-size: 14px;
						color: #1f2d23;
						margin-bottom: 6px;

						.oKey {
							margin-right: 106px;
						}
					}

					.oTit {
						.oKey {
							font-size: 16px;
							font-weight: 600;
						}

						.oVal {
							font-size: 16px;
							color: @desk-font-color;
						}
					}
				}
			}
		}

		.handle {
			width: 100%;
			height: 80px;
			padding-top: 16px;
			box-sizing: border-box;
			background: yellow;
			background: #ffffff;
			box-shadow: 0px 0px 6px 0px #ebeced;
			text-align: right;

			button {
				width: 136px;
				height: 48px;
				background: @desk-color;
				border-radius: 4px;
				font-size: 18px;
				color: #ffffff;
				border: none;
				cursor: pointer;
				margin-right: 20px;
			}
		}
	}
}

// 打印
.print-box {
	font-size: 22px;
	position: absolute;
	width: 365px;
	padding: 20px;
	padding-top: 20px;
	padding-left: 0px;
	left: 0px;
	top: 10px;
	display: flex;
	flex-direction: column;
	line-height: 30px;
	background: #fff;

	.print-title {
		display: flex;
		justify-content: center;
		align-items: center;
		font-size: 26px;
		padding-top: 20px;
		font-weight: 600;
	}

	.border-b {
		border-bottom: 1px solid #333;
	}

	.print-out {
		display: flex;
		flex-direction: column;

		.item-print {
			display: flex;
			justify-content: flex-start;
			align-items: center;

			.print-label {
				font-weight: 600;
			}

			.print-content {
				font-weight: 600;
			}
		}
	}
}

.refundSub {
	width: 100%;
	height: 100vh;
	background: #f4f6f7;
	display: flex;

	.refundLeft {
		width: 441px;
		height: 100vh;
		background: #fff;
		margin-right: 12px;
	}

	.refundright {
		flex: 1;
		height: 100vh;
		background: #fff;

		.oheader {
			height: calc(100vh - 82px);
			padding: 20px;
			box-sizing: border-box;

			.detailHead {
				width: 100%;
				background: #f7f9fa;
				padding: 6px 32px;
				box-sizing: border-box;
				margin-bottom: 40px;
				border-radius: 4px;

				ul {
					display: flex;
					flex-wrap: wrap;
					// justify-content: space-between;
					overflow: hidden;

					li {
						list-style: none;
						font-size: 16px;
						color: #1f2d23;

						margin: 8px 0;
						margin-right: 30px;
						// float: left;
						// ma
					}
				}
			}

			.detailBody {
				ul {
					li {
						list-style: none;
						margin-bottom: 25px;

						.tit {
							margin-bottom: 10px;
							font-size: 16px;
							color: #1f2d23;
						}
					}
				}
			}
		}
	}

	.detailFooter {
		width: 100%;
		height: 80px;
		background: #ffffff;
		box-shadow: 0px 0px 6px 0px #ebeced;
		text-align: right;

		.cancel,
		.affirm {
			width: 136px;
			height: 48px;
			border-radius: 4px;
			font-size: 18px;
			outline: none;
			cursor: pointer;
			border: 2px solid @desk-color;
			margin-top: 16px;
		}

		.cancel {
			background: #fff;
			color: @desk-font-color;
			margin-right: 12px;
		}

		.affirm {
			background: @desk-color;
			color: #fff;
			margin-right: 20px;
		}
	}
}

/deep/ .is-active::after {
	content: "";
	width: 0;
}

.chooseDia {
	box-sizing: border-box;

	.tit {
		margin-bottom: 14px;
		font-size: 18px;
	}
}

/deep/ .el-radio__label {
	font-size: 16px;
}

/deep/.el-input {
	font-size: 18px;
}
</style>



// WEBPACK FOOTER //
// src/views/order.vue